import React from "react";
export const tooltips = [
  {
    name: "Contacts_Groups",
    tooltipText: "Create custom groups to easily organize your contacts. Simply type a name for your new group in this field. After the group is created, you can select contacts from your list to add them. For example, you could create groups for \"Family,\" \"Business Associates,\" or \"Clients.\"",
  },
  {
    name: "Contacts_Update_Groups",
    tooltipText: "Click here to save any changes you've made to this group. This includes adding or removing members by checking or unchecking the boxes next to their names.",
  },
  {
    name: "Contacts_Connect_With",
    tooltipText: "Save time by connecting directly to your existing contact providers like Outlook, Google, or iCloud. Once imported, these contacts will be available in dropdown menus throughout the planner, making it easier to assign tasks and manage your financial plan.",
  },
  {
    name: "Tax_State_Taxation",
    tooltipText: "Select the state where you file your income taxes. This will help tailor tax calculations to your specific location, as tax laws and rates vary by state. If you reside in a state with no income tax, you can indicate that here.",
  },
  {
    name: "Tax_Tax_Filing_Election",
    tooltipText: "Choose your tax filing status from the dropdown menu (e.g., Single, Married Filing Jointly, Head of Household). This status determines your standard deduction, tax brackets, and eligibility for certain credits, which is crucial for accurate tax projections.",
  },
  {
    name: "Tax_Deductions",
    tooltipText: "Select your deduction method. You can choose the 'Standard Deduction,' which is a fixed amount based on your filing status, or 'Itemized Deductions' if you plan to list specific deductible expenses like mortgage interest or charitable contributions.",
  },
  {
    name: "Tax_State_Tax_Effective_Rate",
    tooltipText: "Enter your average state income tax rate. This is your total state tax paid divided by your taxable income. If you are unsure, you can find this on your most recent state tax return or consult with a tax professional.",
  },
  {
    name: "Tax_Federal_Tax_Rate",
    tooltipText: "Enter your average federal income tax rate (also known as the effective tax rate). This is calculated by dividing your total federal tax liability by your total taxable income. This provides a more accurate projection than using your marginal tax bracket alone.",
  },
  {
    name: "Tax_Total_Tax_Rate",
    tooltipText: "This field will automatically calculate your combined effective tax rate by adding your State and Federal tax rates. It represents the overall percentage of your income paid in taxes.",
  },
  {
    name: "Tax_Federal_Collectible_Tax_Rate",
    tooltipText: "Enter the tax rate applied to long-term capital gains from collectibles, such as art, antiques, or precious metals. The IRS taxes these gains at a maximum rate of 28%. Enter 0 if this does not apply to you.",
  },
  {
    name: "Tax_Federal_Long-term-Cap_Gains",
    tooltipText: "This is the tax rate on profits from selling assets you have owned for more than one year. These gains are typically taxed at lower rates (0%, 15%, or 20%) than your ordinary income, depending on your income level.",
  },
  {
    name: "Tax_Federal_Short-term-Cap_Gains",
    tooltipText: "This is the tax rate on profits from selling assets you have owned for one year or less. These gains do not receive a special tax rate and are taxed as ordinary income according to your federal income tax bracket.",
  },
  {
    name: "Tax_State_Long-term-Cap_Gains",
    tooltipText: "This is the tax rate on profits from selling assets you have owned for more than one year. In California, there is no distinction between long-term and short-term gains; both are taxed as ordinary income according to the state's income tax brackets.",
  },
  {
    name: "Tax_State_Short-term-Cap_Gains",
    tooltipText: "This is the tax rate on profits from selling assets you have owned for one year or less. In California, these gains are taxed as ordinary income, subject to the same state income tax brackets as your wages or other earnings.",
  },
  {
    name: "Tax_Carry_Forward",
    tooltipText: "This section is for tracking capital losses from previous years that can be used to reduce your taxable income in the current year. If you had a net capital loss on a prior tax return, you can \"carry forward\" that loss to offset future capital gains. You can also use up to $3,000 of this loss per year to reduce your ordinary income. Please enter any available carryforward losses from your previous tax returns below.",
  },
  {
    name: "Tax_General_Inflation_Rate",
    tooltipText: "Enter the expected average annual rate of inflation. This rate is used to project the future cost of your general living expenses and to adjust the value of your financial goals over time, ensuring your plan reflects future purchasing power. A common benchmark for this is the Consumer Price Index (CPI).",
  },
  {
    name: "Tax_Medical_Inflation_Rate",
    tooltipText: "Enter the expected annual rate of inflation specifically for healthcare costs. This rate, which often outpaces general inflation, is used to project future expenses for medical services, insurance premiums, and long-term care, which is crucial for retirement planning.",
  },
  {
    name: "Tax_Education_Inflation_Rate",
    tooltipText: "Enter the expected annual rate of increase for education costs. This rate is used to project the future cost of tuition, fees, and room and board for college or private school. It is essential for accurately funding any education-related financial goals.",
  },
  {
    name: "Tax_Luxury_Inflation_Rate",
    tooltipText: "Enter the expected inflation rate for luxury goods and services (e.g., high-end travel, vehicles, jewelry). This allows for more precise planning for specific lifestyle goals that involve significant discretionary spending on non-essential items.",
  },
  {
    name: "Tax_Housing_Inflation_Rate",
    tooltipText: "Enter the expected annual appreciation rate for real estate. This rate impacts the future value of your home, potential rental income, and property taxes. It is a key factor in calculating your future net worth and planning for real estate-related goals.",
  },
  {
    name: "Income_Name",
    tooltipText: "Give this income source a descriptive name to easily identify it later. For example, \"Sarah's Salary at Google\" or \"Rental Income from Main St.\"",
  },
  {
    name: "Income_Owner",
    tooltipText: "Select the person who receives this income. The owner's profile will determine how this income is factored into tax calculations and financial goals.",
  },
  {
    name: "Income_Gross_Monthly",
    tooltipText: "Give this income source a descriptive name to easily identify it later. For example, \"Sarah's Salary at Google\" or \"Rental Income from Main St.\"",
  },
  {
    name: "Income_Gross_Monthly_Employee",
    tooltipText: <div>Enter the total compensation earned for a single pay cycle before any taxes, health insurance premiums, or retirement contributions are removed. This value acts as the mathematical <strong>anchor</strong> for your annual income projection. For example, if you are paid monthly, this should match the <strong>Gross Pay</strong> line item found on a single monthly paystub.</div>,
  },
  {
    name: "Income_Frequency_of_Pay_Periods",
    tooltipText: "Select how often this income is received (e.g., weekly, bi-weekly, monthly). This helps the system accurately project your annual income and cash flow throughout the year.",
  },
  {
    name: "Income_Date_Income_Starts",
    tooltipText: "Enter the first date you will receive this income. If you are already receiving this income, you can leave today's date or enter the original start date.",
  },
  {
    name: "Income_Date_Income_Ends",
    tooltipText: "Enter the date this income is expected to end, such as a contract end date or planned retirement date. This is essential for accurate long-term financial forecasting.",
  },
  {
    name: "Income_No_End_Date",
    tooltipText: "Check this box if the income does not have a known end date and is expected to continue indefinitely. The system will project this income continuing until the owner's planned retirement age.",
  },
  {
    name: "Income_Federal_Taxation_Type",
    tooltipText: "Select the category that best describes this income for federal tax purposes. This choice determines which tax rates apply. Common types include 'Ordinary Income' for wages, 'Capital Gains' for investment profits, or 'Tax-Exempt' for non-taxable sources.",
  },
  {
    name: "Income_State_Taxation_Type",
    tooltipText: "Select the category for this income for state tax purposes. While often the same as the federal type, some income sources (like interest from U.S. Treasury bonds) may be treated differently by your state.",
  },
  {
    name: "Income_Adjusted_Gross_Income",
    tooltipText: "Indicate if this income is included in the calculation of your Adjusted Gross Income (AGI). Most earned and investment income is included. AGI is a critical figure used to determine your eligibility for various tax deductions and credits. Select 'Yes' for most income types.",
  },
  {
    name: "Income_Passive_or_Active",
    tooltipText: "Specify if this is active or passive income. Active income is earned from services you perform or a business you materially participate in (e.g., salary, consulting fees). Passive income is from activities where you are not actively involved, such as most rental properties or limited partnerships. This classification is crucial for tax rules regarding losses.",
  },
  {
    name: "Income_Amount_Subject_to_Fed_Taxation",
    tooltipText: "Enter the total dollar amount of this income that is taxable by the federal government. For some income types, like Social Security, this may only be a portion of the total received. For standard wages, this would be your gross income.",
  },
  {
    name: "Income_Amount_Subject_to_Fed_Taxation_Employee",
    tooltipText: "This calculated value represents your federally taxable income after subtracting specific pre-tax adjustments. The software automatically reduces your Gross Pay by traditional 401(k) or 403(b) deferrals and HSA contributions entered in Form 2, while correctly excluding after-tax Roth contributions. Under the 2026 OBBBA, this figure also accounts for new deductions available for qualified overtime and tips.",
  },
  {
    name: "Income_Net_Amount",
    tooltipText: "Enter the final, after-tax dollar amount received from this income source. This figure represents the actual cash that will be used in your financial plan and cash flow projections. This may be auto-calculated based on your previous selections.",
  },
  {
    name: "Income_Net_Amount_Employee",
    tooltipText: <div>This is the estimated <strong>cash-in-pocket</strong> amount that actually reaches your bank account each pay period. It is calculated by taking your Gross Pay and subtracting all withholdings captured in Form 2, including Federal and State income taxes, Social Security (monitored against the $184,500 2026 wage base), Medicare, disability, and all benefit or retirement deductions. This figure is what drives the spendable <strong>Net Line</strong> on your Income Dashboard.</div>,
  },
  {
    name: "Important_Documents_Organizer",
    tooltipText: "Use these modules to build a complete picture of your current finances. Click on a category like \"Assets\" or \"Insurance\" to upload, view, and manage important related documents such as deeds, titles, loan agreements, and policy statements.",
  },
  {
    name: "Important_Documents_Planner",
    tooltipText: "Use these modules to plan for your future financial success. Click on a category like \"Goals\" or \"Social Security\" to upload, view, and manage key documents that support your long-term strategies, such as goal worksheets or benefit statements.",
  },
  {
    name: "Important_Documents_Protector",
    tooltipText: "Use these modules to secure your financial legacy and plan for life's uncertainties. Click on a category like \"Death & Estate\" to upload, view, and manage your most critical documents, including wills, trusts, and power of attorney forms.",
  },
  {
    name: "Assets_Plaid_Sync_Column",
    tooltipText: "This icon indicates that the account is securely linked with our trusted financial data provider, allowing for real-time balance updates and transaction synchronization. The connection enables seamless financial tracking without manual entry.",
  },
  {
    name: "Assets_Collectible_Details",
    tooltipText: "This section displays your valuable collectible items, such as art, coins, wine, or antiques. These are typically tracked for their monetary value and potential appreciation over time as part of your overall net worth.",
  },
  {
    name: "Assets_Inventory_Details",
    tooltipText: "This section is your detailed home and property inventory. You can create properties, define rooms within them, and log individual items. This powerful organization allows you to track values, warranty information, and locations. In the event of a disaster, this detailed record becomes essential for accurately and efficiently filing insurance claims.",
  },
  {
    name: "Assets_Future_Asset_Details",
    tooltipText: "This section shows assets that will be created in your financial plan's projections. This occurs when an illiquid asset (like property) is designated to be sold in the future to fund a goal. If the asset's value exceeds the goal amount, the remaining cash from the sale will appear here as a new \"Future Asset\" available for your use after the sale.",
  },
  {
    name: "Assets_Name_of_Asset",
    tooltipText: "Give this asset a unique name for easy identification, such as a property address, vehicle model, or account number.",
  },
  {
    name: "Assets_Owner",
    tooltipText: "Select the legal owner(s) of the asset. This is important for calculating net worth and for estate planning purposes.",
  },
  {
    name: "Assets_Account_Type_Titled",
    tooltipText: "Specify how the asset is legally titled (e.g., Individual, Joint, LLC, or in a Trust). The title affects ownership rights and how the asset is treated in legal or estate matters.",
  },
  {
    name: "Assets_Produces_Income",
    tooltipText: "Select 'Yes' if this asset generates income, such as a rental property that produces rent. This will allow you to track the associated revenue in your financial plan.",
  },
  {
    name: "Assets_has_Loan",
    tooltipText: "Select 'Yes' if there is an outstanding loan on this asset. This allows you to link the asset to its corresponding liability to accurately calculate your net equity.",
  },
  {
    name: "Assets_Share_with_Financial_Advisor",
    tooltipText: "Choose whether to make this asset's information visible to your financial adviser. Select 'No' to keep this entry private within your own view.",
  },
  {
    name: "Assets_Held_Where",
    tooltipText: "Enter the physical location of the asset (e.g., a property address) or the name of the financial institution where it is held (e.g., 'Fidelity Investments').",
  },
  {
    name: "Assets_Status_of_Asset",
    tooltipText: "Select the current status of the asset (e.g., Owned, Pending, Sold, Not Owned). This helps provide a more accurate and up-to-date view of your financial situation.",
  },
  {
    name: "Assets_Taxability_while_Owned",
    tooltipText: "Select how this asset is taxed during the time you own it, before it's sold. For example, interest from a savings account is 'Taxable' annually, a non-dividend stock is 'Tax-Deferred,' and interest from a municipal bond may be 'Tax-Exempt.'",
  },
  {
    name: "Assets_Taxability_on_Distribution",
    tooltipText: "Select the tax treatment when this asset is sold, withdrawn, or distributed. For instance, qualified withdrawals from a Roth account are 'Tax-Free,' while withdrawals from a Traditional IRA are 'Taxed as Ordinary Income.' The sale of a stock is subject to 'Capital Gains' tax.",
  },
  {
    name: "Assets_Status_of_Asset",
    tooltipText: "Indicate if this asset can be converted to cash quickly (typically within a few days) with minimal loss of value. Yes: Select for liquid assets like cash, savings/checking accounts, and publicly traded stocks or bonds. No: Select for illiquid assets like real estate, collectibles, or private business interests.",
  },
  {
    name: "Liabilities_Future_Loan",
    tooltipText: "This indicates a loan that is scheduled to be created in your financial plan to fund a future goal. A Future Loan is automatically generated when you specify that you will borrow money to meet a goal's funding needs. For example, a planned student loan for college or a mortgage for a future home purchase would appear here, allowing the system to accurately forecast your future debt and cash flow.",
  },
  {
    name: "Liabilities_Name_of_Liability",
    tooltipText: "Give this liability a unique name for easy identification. For example, 'Primary Mortgage,' 'Student Loan,' or 'Chase Credit Card.'",
  },
  {
    name: "Liabilities_Owner",
    tooltipText: "Select the person or people who are legally responsible for this debt. This is crucial for accurately calculating net worth and creating an effective debt management plan.",
  },
  {
    name: "Liabilities_Intial_Loan_Amount",
    tooltipText: "Enter the original principal amount of the loan when it was first initiated.",
  },
  {
    name: "Liabilities_Start_Date",
    tooltipText: "Enter the date the loan agreement began. This is used with the Maturity Date to calculate the loan's term.",
  },
  {
    name: "Liabilities_Maturity_Date",
    tooltipText: "Enter the date when the final payment on the loan is due and the loan will be fully paid off.",
  },
  {
    name: "Liabilities_Interest_Rate",
    tooltipText: "Enter the annual interest rate for this loan. This is a key component for calculating your monthly payment.",
  },
  {
    name: "Liabilities_Monthly_Payment",
    tooltipText: "This is the fixed amount you pay each month towards the loan. This field will be calculated automatically if you provide the Initial Loan Amount, Start Date, Maturity Date, and Interest Rate.",
  },
  {
    name: "Liabilities_Account_Number",
    tooltipText: "Enter the unique number that identifies this loan with your lender. For your security, please consider entering only the last four digits.",
  },
  {
    name: "Liabilities_Loan_Balance",
    tooltipText: "Enter the current outstanding amount you owe on this loan.",
  },
  {
    name: "Liabilities_Monthly_Payment_Due",
    tooltipText: "Select the day of the month that your payment is due.",
  },
  {
    name: "Liabilities_Name_of_Financial_Institution",
    tooltipText: "Enter the name of the bank or company that issued the loan (e.g., 'Wells Fargo' or 'Toyota Financial Services')",
  },
  {
    name: "Liabilities_Length_of_Loan",
    tooltipText: "This is the remaining time until the loan is fully paid off. This will be calculated automatically for you if the Start Date and Maturity Date are entered.",
  },
  {
    name: "Budget_Income_Expenses",
    tooltipText: "This chart gives you a quick visual summary of your cash flow. It compares your total monthly income to your total monthly expenses, helping you see at a glance whether you are spending more than you earn.",
  },
  {
    name: "Budget_Enter_Budget_Next_12_Months",
    tooltipText: "Tooltip: Use this tool to set your spending plan for the upcoming year. Monthly Tab: Set a unique budget for each of the next 12 months. One-Time Tab: Apply a single, consistent budget amount to all 12 months. Pre-fill from Previous 12 Months: Check this box to automatically populate your new budget based on your actual spending from the last 12 months.",
  },
  {
    name: "Budget_Hide_Categories",
    tooltipText: "Customize your \"Income vs Expenses\" chart by hiding specific spending categories. Unchecking a category will remove all of its associated transactions from the expense bar for all months, allowing you to focus on particular areas of your budget.",
  },
  {
    name: "Goals_Illiquid_Assets",
    tooltipText: "This section lists your illiquid assets, such as real estate, vehicles, or collectibles, which require a formal sale to be converted to cash. To fund your goal, select an asset to sell. The plan will then use the estimated net proceeds from the sale, after accounting for any associated liabilities, taxes, and transaction costs.",
  },
  {
    name: "Goals_Liquid_Assets",
    tooltipText: "This section lists your liquid assets, such as checking, savings, and brokerage accounts, which can be used to fund a goal without a complex sale. You can either use the existing balance to fund the goal or choose to save to this asset over time. If you choose to save, the system will calculate the monthly contribution needed to reach your goal.",
  },
  {
    name: "Goals_Assets_to_Assign_to_Goal",
    tooltipText: "This table provides a summary of all assets you have already assigned to fund this specific goal. It details which assets are being used, how much of their value is allocated, and in what order they will be used, giving you a clear picture of your current funding strategy.",
  },
  {
    name: "Goals_Assign_savings_to_Goal",
    tooltipText: "In this section, you can designate specific savings or investment accounts to fund this goal over time. Detail your monthly contribution plan for each account you wish to use.",
  },
  {
    name: "Goals_Current_Information",
    tooltipText: "This section provides a summary of your overall savings situation, helping you understand your capacity to save versus what is needed for your goals.",
  },
  {
    name: "Goals_Loan_End_Date",
    tooltipText: "Please enter your best estimate for when this future loan will be fully paid off. Even though this date is in the future and may be variable, it is required to create a detailed amortization schedule for a comprehensive financial plan.",
  },
  {
    name: "Goals_Loan_Interest_Rate",
    tooltipText: "Enter your best estimate for the interest rate on this future loan. You can use current market rates for similar loans as a guide. This estimated rate is required to create a realistic amortization schedule and project the true cost of borrowing within your financial plan.",
  },
  {
    name: "Goals_Total_Loan_Assigned_to_Goal",
    tooltipText: "This field is automatically calculated for you. It represents the remaining funding amount needed to achieve this goal after all other sources—such as savings, assigned assets, and assistance from friends and family—have been applied. This is the principal amount that will be used for your future loan.",
  },
  {
    name: "Divorce_Personal_Information",
    tooltipText: "This section captures the foundational details needed for divorce planning. The Marriage Date and Separation Date are legally significant and are used to establish the timeline for dividing marital assets and debts. Providing accurate information here is a critical first step in creating a comprehensive and equitable plan.",
  },
  {
    name: "Divorce_Asset_Documentation",
    tooltipText: "This section is for cataloging all your assets to create a complete financial picture for the divorce proceedings. Use the subforms below to enter detailed information about your financial accounts, real estate, vehicles, and valuable personal property. A thorough and transparent inventory is crucial for ensuring all assets are accounted for and can be properly valued for a fair settlement.",
  },
  {
    name: "Divorce_Income_Information",
    tooltipText: "This section is for detailing all sources of income for both you and your spouse. A complete and accurate disclosure of income is essential for calculating potential support payments (like alimony and child support) and ensuring a fair financial settlement. Use the forms below to enter details about your personal income, your spouse's income, and any income generated from business interests.",
  },
  {
    name: "Divorce_Debt_Liabilities",
    tooltipText: "This section is for creating a complete inventory of all outstanding debts. A clear and honest accounting of all financial obligations is essential for a fair division of responsibilities. Use the forms below to distinguish between joint debts acquired during the marriage, individual debts, and any debts that existed before the marriage. This detailed list will be crucial for negotiating your settlement.",
  },
  {
    name: "Divorce_Monthly_Budget",
    tooltipText: "This section helps you analyze both your historical spending and your projected future expenses. Documenting the average monthly budget during the marriage is a key step for financial disclosures and support calculations. Creating a separate post-divorce budget is essential for planning your new financial reality and ensuring your future stability.",
  },
  {
    name: "Divorce_12-Month_Average_Monthly_Budget",
    tooltipText: "Enter the average amount your household spent each month during the marriage. This figure is used as a baseline to understand your family's historical spending habits and is often required for financial disclosure during divorce proceedings.",
  },
  {
    name: "Divorce_Post-Divorce_Budget",
    tooltipText: "Enter your best estimate of what your total monthly expenses will be after the divorce is finalized. This helps you plan for your new financial reality and is crucial for determining future support needs.",
  },
  {
    name: "Divorce_Add_Category",
    tooltipText: "Select a spending category from the dropdown list to add it to your budget breakdown below. This allows you to detail your expenses and see where your money is going.",
  },
  {
    name: "Divorce_Categories",
    tooltipText: "Current Monthly Budget: Click here to view and manage the detailed breakdown of your average monthly expenses during the marriage. Post Divorce Budget: Click here to view and manage the detailed breakdown of your projected monthly expenses for after the divorce.",
  },
  {
    name: "Divorce_Insurance_Coverage",
    tooltipText: "This section is for cataloging all of your current insurance policies. Decisions about continuing coverage for health, life, and property insurance are a critical part of any divorce settlement. Use this module to detail each policy, including who is covered, the coverage amounts, and any special riders. This ensures all policies are considered when negotiating your final agreement.",
  },
  {
    name: "Divorce_Legal_Documentation",
    tooltipText: "This section is for cataloging the details of all legally binding documents that could impact your divorce settlement. A thorough record of these agreements is essential for understanding your rights and obligations and for ensuring a fair and legally sound outcome.",
  },
  {
    name: "Divorce_Marriage_Documents",
    tooltipText: "Use this section to record details from documents that legally define your marriage and any related financial agreements. This includes prenuptial or postnuptial agreements, which may govern how assets are divided, as well as any previous divorce decrees that could affect your current financial obligations.",
  },
  {
    name: "Divorce_Legal_Documentation_2",
    tooltipText: "Use this section to detail other significant legal records such as trusts, wills, and business agreements. These documents are a critical part of your financial picture and will likely need to be reviewed and updated as a result of the divorce, especially if your spouse is named as a beneficiary, trustee, or power of attorney.",
  },
  {
    name: "Divorce_Child_Custody_Considerations",
    tooltipText: "This section is designed to help you create a detailed and comprehensive co-parenting plan. Use these fields to think through and document your preferences on key topics, from visitation schedules to important decisions about education, healthcare, and religion. Creating a thorough plan now helps provide stability for your children, minimizes future conflict, and serves as a strong foundation for your legal custody agreement.",
  },
  {
    name: "Divorce_Business_Interests",
    tooltipText: "This section is for detailing any business interests owned by you or your spouse. A business is a significant marital asset that must be properly valued for a fair divorce settlement. Use the fields and sub-sections below to document the ownership structure, the business's current valuation, and provide details on critical components like its assets, financial statements, tax returns, and partnership agreements. A complete record is essential for an equitable division.",
  },
  {
    name: "Divorce_Support_Calculations",
    tooltipText: "This section is for detailing all the specific income, adjustments, and expenses used to determine potential child and spousal support amounts. The calculations made here are based on state guidelines and are a critical part of financial planning for divorce. A thorough and accurate entry of all relevant financial data is essential for a fair and equitable outcome.",
  },
  {
    name: "Divorce_Professional_Team",
    tooltipText: "Navigating a divorce often requires a team of experts. Use this section as a central directory to keep track of the contact information and notes for your attorney, financial advisor, therapist, and any other professionals assisting you. Keeping this information organized makes it easier to manage your case and coordinate with your support team.",
  },
  {
    name: "Death_Start_Here",
    tooltipText: "This module is designed to help you organize your critical end-of-life information, making things easier for your loved ones during a difficult time. It serves as a central, secure place to outline instructions and consolidate the details your family will need to ensure your final wishes are understood and respected.",
  },
  {
    name: "Death_Advance_Healthcare_Directives",
    tooltipText: "An Advance Healthcare Directive is a legal document that specifies your wishes for medical care if you are unable to make decisions for yourself. Upload a copy here to ensure your family and trusted individuals have immediate access to this critical document when it's needed most. Click the plus icon to add your file.",
  },
  {
    name: "Death_MESSAGE_Created_for_People_Like_You",
    tooltipText: "You are taking a thoughtful and responsible step. Planning for the inevitable is a profound act of love and foresight. This module was created for people like you who choose to provide clarity and peace of mind for their loved ones, ensuring their plan is organized and their wishes are clear.",
  },
  {
    name: "Death_MESSAGE_To_help_protect_those",
    tooltipText: "Your greatest asset is your family. By organizing your financial life and final wishes now, you are protecting those you care about from the unnecessary stress, confusion, and potential conflicts that can arise from a lack of clear direction. This is your plan to make a difficult time more manageable for them.",
  },
  {
    name: "Death_MESSAGE_Emotional_and_Analytical_Map",
    tooltipText: "This plan is more than just numbers and assets; it's a reflection of your life and legacy. We provide an \"emotional and analytical map\" where you can outline not only the financial and logistical details (the analytical) but also your personal wishes, letters, and instructions (the emotional), leaving a complete guide for your loved ones.",
  },
  {
    name: "Death_MESSAGE_See_Welcome_Message",
    tooltipText: "When the time comes, the person you entrust with your affairs will receive a welcome message guiding them through this plan (Click HERE for Welcome Message). This message is designed to give them confidence and a clear starting point, letting them know that you have created a comprehensive map for them to follow during a difficult time.",
  },
  {
    name: "Death_MESSAGE_See_Welcome_Message_WELCOME_MESSAGE",
    tooltipText: "The team at Asset Planet extends our heartfelt sympathy for your loss. The person who created this plan did so as a final act of care, with the goal of making this process as clear and manageable for you as possible. Now that you have accessed the plan, it has been secured in a view-only mode. You can freely explore all the information without any concern of accidentally deleting or changing what has been saved. A great place to begin is the checklist your loved one prepared to guide you on the initial steps. Inside, you will find a comprehensive guide, including important documents, key contacts, and even ready-to-send email messages to assist you with notifications. Everything is organized to reduce stress and help you navigate the tasks ahead. Please know that you do not need to be a technical expert to use this platform. Each page has help icons (?) to provide guidance. If you need further assistance, our team is here to help. Please don't hesitate to reach out to us through our \"Contact Us\" page.",
  },
  {
    name: "Death_MESSAGE_An_easy_way_to_reduce",
    tooltipText: "In the emotional days following a loss, searching for documents, accounts, and contacts can be overwhelming. This module acts as a central, secure hub for everything your family will need, from legal documents to digital passwords. It’s a simple and powerful way to reduce chaos and provide a clear path forward.",
  },
  {
    name: "Death_MESSAGE_More_in_our_Knowledge_Base",
    tooltipText: "End-of-life planning can bring up many questions. For more information, checklists, and articles on topics like estate planning, trusts, and digital legacies, please visit our comprehensive Knowledge Base. We're here to provide the resources you need to make informed decisions.",
  },
  {
    name: "Death_Audio_Video_Messages",
    tooltipText: "This section allows you to leave a deeply personal and lasting gift for your loved ones. You can record or upload separate audio and video messages for your spouse, family, and friends. This is your opportunity to share final thoughts, express your love, or offer words of comfort and guidance in your own voice, creating a priceless final connection.",
  },
  {
    name: "Death_Checklist",
    tooltipText: "This checklist is your personal roadmap for creating a complete and comprehensive plan. Use it to track your progress through each section, from outlining personal instructions to listing important documents. It helps you see what you've accomplished and what still needs your attention, ensuring no critical information is overlooked.",
  },
  {
    name: "Death_Personal_Instructions",
    tooltipText: "This section is for leaving specific, practical instructions that may not be covered in formal legal documents. Think of it as a place for helpful notes to your loved ones. You can provide details on the location of important items (like spare keys or a safe deposit box), instructions for handling personal belongings, or any other piece of information that will make managing your affairs easier for them.",
  },
  {
    name: "Death_Contact_List",
    tooltipText: "This section is your central directory for everyone your loved ones may need to contact. You can grant special access to one or more people by designating them as a Trusted Individual. A Trusted Individual will be able to view the information in this entire module after your death to help manage your affairs. An invitation is automatically sent to Trusted Individuals upon their addition to this module, and to re-invite someone to be a Trusted Individual, click the Copy Link button next to their name. Send this unique, secure link to them. It will allow them to formally accept or decline this important role. You can track their response in the \"Trusted Status\" column.",
  },
  {
    name: "Death_Emails_and_Texts_to_Send_After_Death",
    tooltipText: "This powerful feature allows you to ease the burden on your loved ones by pre-writing important notifications. You can compose emails and text messages now that your Trusted Individual can send with a single click after your passing. The content you write is locked and cannot be edited, ensuring your exact words are sent to employers, organizations, or friends. This provides a simple way to handle the difficult task of communication during a stressful time.",
  },
  {
    name: "Death_Funeral_Wishes",
    tooltipText: "This section is your opportunity to outline your specific wishes for your funeral and memorial service. By detailing your preferences for burial, the service, and personal touches like music or speakers, you remove guesswork for your family. Providing this clear guidance is a final gift that can relieve a significant emotional burden and ensure your farewell truly reflects your personality.",
  },
  {
    name: "Death_Prepaid_Burial_Expenses",
    tooltipText: "Use this section to record any funeral or burial expenses that you have already paid for in advance. Documenting items like a prepaid burial plot, casket, or funeral home services prevents duplicate payments and informs your loved ones about existing arrangements. This can greatly reduce the financial stress on your family during a difficult time.",
  },
  {
    name: "Death_List_of_Passwords",
    tooltipText: "This section provides a secure way to give your trusted representative access to your important digital accounts, applications, and physical items. Properly documenting this information is crucial for allowing your loved ones to manage your financial affairs, close accounts, and preserve your digital legacy. You can either upload a master password document or add individual entries below. For your security, consider providing strong hints or instructions rather than typing the actual passwords directly.",
  },
  {
    name: "Death_Bills_to_Pay",
    tooltipText: "This section is your central hub for tracking and managing all upcoming bills. Add your recurring and one-time payments to stay organized, avoid late fees, and manage your cash flow effectively. You can visualize your payment schedule using the 'Calendar' view or switch to the 'List' view for a chronological summary.",
  },
  {
    name: "Death_Assets_and_Liabilities",
    tooltipText: "This section provides a consolidated, read-only summary of your complete financial picture. All information shown here is automatically populated from the main 'Assets' and 'Liabilities' modules. To add or update an item, please visit the respective module. This comprehensive overview is essential for your trusted individuals to understand your net worth and manage your estate effectively.",
  },
  {
    name: "Death_Important_Documents",
    tooltipText: "This section is your central catalog for all essential documents and is critically important for helping your loved ones manage your affairs. Here, you can both upload digital copies of files and, just as importantly, specify the physical storage location of original documents (e.g., \"Will in safe deposit box\" or \"Passport in fireproof safe\"). This comprehensive index will save your family immense time and stress when they need to locate your most important paperwork.",
  },
  {
    name: "Death_Litigation",
    tooltipText: "Use this section to document any ongoing lawsuits or legal disputes you are involved in, whether you are suing someone or being sued. Providing details about potential financial outcomes and attaching relevant files will give your executor or trustee a clear understanding of these situations, which is essential for managing your estate properly.",
  },
  {
    name: "Death_Location_of_Personal_Items",
    tooltipText: "This section helps you create a clear record of where your important personal belongings are located. This prevents confusion and ensures that items of financial or sentimental value are not lost or overlooked. You can list anything from jewelry and family heirlooms to hidden valuables, providing a helpful map for your loved ones to follow.",
  },
  {
    name: "Disability_Employment_Information",
    tooltipText: "This section captures the details of your primary employment. This information is the foundation for disability planning, as it helps establish your current income level. It is essential for calculating the potential financial gap you would face if you were unable to work and for determining if your current disability insurance is adequate.",
  },
  {
    name: "Disability_Other_Income",
    tooltipText: "Use this section to list all sources of income outside of your main job, such as rental income, investments, or freelance work. It is important to consider which of these income streams would continue if you were to become disabled. This provides a more complete picture of your financial situation and helps identify any income that may not be covered by traditional disability insurance.",
  },
  {
    name: "Disability_Medical_Information",
    tooltipText: "This section is for creating a centralized record of your key medical providers and preferences. In the event of a disability where you may be unable to communicate, this information is essential for your family or advocate to manage your healthcare effectively. It ensures they know exactly who your doctors are and what your hospital and pharmacy preferences are, which is also critical when filing for disability benefits.",
  },
  {
    name: "Disability_Medical_History",
    tooltipText: "This section allows you to create a comprehensive record of your complete medical background. This information is vital for disability planning as it is often required when applying for insurance and provides essential context when filing a claim. It also allows you to project potential future medical costs, which is a key part of your financial plan. Having this history in one place ensures your family or medical team can provide the best care in an emergency.",
  },
  {
    name: "Disability_Insurance_Coverage",
    tooltipText: "This section is a crucial tool for analyzing your existing disability insurance coverage. Enter the details of all your policies, including group plans from your employer and any private policies you own. The system will then calculate your total coverage and compare it against your needs to determine if you are over or under-covered. This analysis helps you identify any potential income gaps and understand how much you might need to self-fund, ensuring you are financially prepared for a disability.",
  },
  {
    name: "Disability_Assets",
    tooltipText: "This section provides a consolidated, read-only summary of your complete financial picture. To add or update an item, please visit the main 'Assets' and 'Liabilities' modules, as all data is populated automatically from there. Understanding your overall net worth is a critical step in disability planning, helping you to clearly see the resources you would have available to cover expenses if you were unable to work.",
  },
  {
    name: "Disability_Liabilities",
    tooltipText: "This section provides a consolidated, read-only summary of your complete financial picture. To add or update an item, please visit the main 'Assets' and 'Liabilities' modules, as all data is populated automatically from there. Understanding your overall net worth is a critical step in disability planning, helping you to clearly see the resources you would have available to cover expenses if you were unable to work.",
  },
  {
    name: "Disability_Budget",
    tooltipText: "This section is a crucial planning tool for creating a hypothetical budget in a disability scenario. Since your income would likely be reduced if you became disabled, this tool helps you proactively decide how to adjust your spending to match that new reality. First, establish your current average budget, then use the sliders to reduce discretionary spending in various categories. This exercise helps you understand the financial adjustments you would need to make and better prepares you for a potential change in your financial life.",
  },
  {
    name: "Disability_Legal_Documents",
    tooltipText: "This section is for cataloging the essential legal documents that protect you and your assets if you become disabled. Documents like a Living Will, Trust, and Healthcare Power of Attorney legally define your wishes and grant authority to the people you choose to make decisions on your behalf. Having these prepared and accessible is critical for ensuring your instructions are followed and can prevent your family from having to go through stressful court proceedings to manage your affairs.",
  },
  {
    name: "Disability_Primary_Caregivers",
    tooltipText: "This section is for identifying the key people who would help care for you in the event of a disability. Use this list to designate your primary caregivers and outline their potential roles and responsibilities, such as assisting with medical appointments, managing daily tasks, or providing financial help. Creating a clear plan provides direction for your loved ones and ensures you have a reliable support structure in place when you need it most.",
  },
  {
    name: "Disability_Professional_Contacts",
    tooltipText: "This section is for creating a central directory of the professionals you rely on for financial, legal, and healthcare advice. In the event of a disability, your family or advocate will need to coordinate with this team for tasks like filing insurance claims, managing investments, and making legal decisions. Keeping this list updated ensures your support network can act quickly and efficiently on your behalf.",
  },
  {
    name: "Disability_Home_Modifications",
    tooltipText: "This section is for planning and documenting any modifications to make your home safe and accessible in the event of a disability. Use the tables to plan and budget for future projects (like adding a wheelchair ramp or a walk-in shower) and to keep a record of work you have already completed. Thinking through these potential changes and their costs is a critical part of your overall financial plan, ensuring your home can continue to support your needs.",
  },
  {
    name: "Disability_Equipment_Needs",
    tooltipText: "This section is for creating an inventory of all the medical and adaptive equipment required to manage a disability. Beyond just listing items, you can plan for their upkeep by setting a Maintenance Schedule and, critically, a Replacement Schedule. Planning for the replacement of expensive equipment is an essential part of your long-term financial plan, ensuring you can budget for these costs and that your quality of care is never compromised.",
  },
  {
    name: "Disability_Daily_Living_Preferences",
    tooltipText: "This section is for documenting your personal routines and lifestyle preferences to guide your care in the event of a disability. If you need assistance from a caregiver, this information provides them with a clear roadmap to your daily life—from dietary needs and sleep schedules to social activities. Outlining these preferences is a powerful way to ensure your comfort, dignity, and quality of life are maintained, no matter the circumstances.",
  },
  {
    name: "Disability_Treatment_Preferences",
    tooltipText: "This section allows you to clearly state your personal wishes regarding medical care, providing essential guidance for your loved ones and healthcare providers. While legal documents like a Healthcare Power of Attorney appoint a decision-maker, this is where you provide the detailed instructions they should follow. Use these fields to specify your preferred treatments, any restrictions, your approach to pain management, and your end-of-life care wishes. This ensures the care you receive aligns with your personal values, even if you are unable to communicate them yourself.",
  },
  {
    name: "Disaster_Personal_Family_Information",
    tooltipText: "This section is for consolidating the critical information you would need during and immediately after a disaster. When an emergency strikes, family members may be separated and unable to access normal records. Use these fields to document essential details about your household, medical contacts, schools, and workplaces. Designating a safe Meeting Location and an Out-of-State Contact Person are crucial steps for ensuring everyone can reunite and communicate. Having this information organized in one place is key to your family's safety and coordination during a crisis.",
  },
  {
    name: "Disaster_Emergency_Contacts",
    tooltipText: "This section is your central directory for every critical phone number you might need during and after a disaster. When an emergency occurs, you won't have time to search for numbers. Use the fields below to consolidate contact information for family, first responders, utility companies, and insurance agents. Having this list pre-built and accessible is a key step in being prepared to respond quickly and efficiently.",
  },
  {
    name: "Disaster_Property_Documentation",
    tooltipText: "This section is for consolidating all critical information about your property before a disaster strikes. In the event your home is damaged or destroyed, you will need this data to file insurance claims and apply for assistance. Use the sub-sections to detail your property insurance policy, agent contacts, mortgage information, and a comprehensive Inventory of your belongings. A complete record here is essential for a faster, smoother financial recovery.",
  },
  {
    name: "Disaster_Financial_Documentation",
    tooltipText: "This section is for creating a secure, centralized record of your entire financial life. In the aftermath of a disaster, you may be displaced and lose access to physical records. Having a complete digital summary of your assets, debts, income, and passwords is not just a convenience—it's essential for accessing funds, paying bills, filing for aid, and beginning your financial recovery. This consolidated view ensures you have the critical information you need, right when you need it most.",
  },
  {
    name: "Disaster_Important_Document_Storage",
    tooltipText: "This section is for creating an inventory of your most vital records and their physical storage locations. Documents like birth certificates, passports, and social security cards are essential for proving your identity and are often required to apply for disaster assistance. Use this list to record where each original document is kept (e.g., 'Fireproof Safe,' 'Bank Safe Deposit Box,' 'Evacuation Go-Bag'). This serves as both a checklist for a quick evacuation and a record of what needs to be replaced if the originals are lost, saving you immense time and frustration during recovery.",
  },
  {
    name: "Disaster_Emergency_Supplies_Inventory",
    tooltipText: "This section serves as a comprehensive checklist to help you build and track your emergency supply kits. After a major disaster, you should be prepared to be self-sufficient for at least 72 hours. Use this inventory to ensure you have adequate supplies—like water, food, medications, and a first-aid kit—for both a 'Go-Bag' in case of evacuation and a 'Shelter-in-Place' kit for your home. A well-stocked supply kit is the foundation of your disaster plan and provides true peace of mind.",
  },
  {
    name: "Disaster_Evacuation_Planning",
    tooltipText: "This section is for creating your detailed action plan in case of an evacuation order. During a real emergency, you may only have minutes to leave, and thinking clearly can be difficult. Use these fields to pre-plan primary and secondary escape routes, designate safe meeting points for your family (both local and out-of-area), and create specific plans for pets and any household members needing assistance. Having a well-defined evacuation strategy is the key to a safe and coordinated response in a crisis.",
  },
  {
    name: "Disaster_Home_Safety_Security",
    tooltipText: "This section is for documenting the critical safety and security features of your home to protect your property and your family. Knowing the location of utility shutoffs is vital for preventing secondary disasters like fires or flooding. Use these fields to record where your main gas, water, and electricity shutoffs are, the location of emergency equipment, and details about security systems, backup power, or a designated safe room. This information enables you to react quickly and effectively in a crisis.",
  },
  {
    name: "Disaster_Communciation_Plan",
    tooltipText: "This section is for establishing a clear communication strategy for your family in case you are separated during a disaster. Because local phone and internet service can be unreliable in an emergency, it's crucial to have a pre-arranged plan. Use these fields to define your communication protocol, designate meeting locations, and identify an out-of-state contact who can act as a central point of communication for the entire family.",
  },
  {
    name: "Disaster_Passwords",
    tooltipText: "This section is for creating a secure record of your essential passwords. During a disaster, you may need to access financial, insurance, or social media accounts from an unfamiliar device. Having this information consolidated here ensures you can manage your affairs, contact providers, and communicate your status, even if you are evacuated and don't have access to your usual records.",
  },
  {
    name: "Disaster_Insurance_Coverage",
    tooltipText: "This section is for consolidating the details of all your insurance policies that would be relevant after a disaster, such as homeowners, flood, earthquake, and auto insurance. After an emergency, you'll need this information readily available to contact your providers and begin the claims process, which is the first step toward financial recovery. A complete record here is essential for a smooth and timely response.",
  },
  {
    name: "Disaster_Recovery_Plan",
    tooltipText: "This section is for creating your action plan for the recovery phase after a disaster. The period following an emergency can be overwhelming, so having a pre-built plan is essential. Use these fields to outline insurance claim procedures, list trusted contractors, and research options for temporary housing. Importantly, this is also the place to gather information on official disaster assistance programs and vital mental health resources to support your family's well-being. A detailed recovery plan can significantly reduce stress and accelerate the process of getting your life back to normal.",
  },
  {
    name: "Disaster_Business_Continuity",
    tooltipText: "This section is for business owners to create a continuity plan to keep essential operations running during and after a disaster. When your primary workplace is inaccessible, this plan becomes your roadmap. Use these fields to consolidate critical information such as employee and vendor contacts, remote work capabilities, insurance details, and the location of essential documents. A thorough business continuity plan is vital for minimizing downtime, protecting your assets, and ensuring the survival of your business.",
  },
   {
    name: "Trustee_Login",
    tooltipText: "A Trusted Individual is a designated person, like a spouse or financial advisor, who you can grant access to view or manage your Asset Planet account.",
  },
  {
    name: "social_security_tooltip",
    tooltipText: "This section is for providing information about Social Security benefits, eligibility, and application processes.",
  },
  {
    name: "retirement_earnings_tooltip",
    tooltipText: "This section is for providing information about Retirement Earnings Test, eligibility, and application processes.",
  },
  {
    name: "Current Monthly Gap",
    tooltipText: "The estimated additional monthly savings required to fully fund your spending needs through life expectancy.",
  },
  {
    name: "Target Account",
    tooltipText: "Select the account for this contribution. Note: Choosing a Traditional 401k or IRA will apply Pre-Tax logic; Roth or Brokerage will apply Post-Tax logic.",
  },
  {
    name: "Suggested Savings",
    tooltipText: "The monthly amount Asset Planet calculates you should save in this specific account to close your retirement gap, assuming projected investment returns.",
  },
  {
    name: "Your Commitment",
    tooltipText: "How much you plan to save monthly. This amount is assumed to continue until retirement age.",
  },
  {
    name: "Remaining Monthly Gap",
    tooltipText: "The monthly shortfall that still remains after accounting for your new commitment. If this is $0 (or negative), you are on track.",
  },
  {
    name: "Funds Last Until Age",
    tooltipText: "Based on your current assets plus this new savings commitment, this is the age your portfolio is projected to reach $0.",
  },

  //NEW NEW NEW Start December, 2025
  //These are new and need to be added to the platform
  {
    name: "",
    tooltipText: "",
  },
  // Tax and Inflation
  {
    name: "city_of_residence",
    tooltipText: "Please enter the city where you maintain your primary residence. This information helps us account for any specific local tax implications or municipal considerations that may affect your overall financial picture.",
  },  
  {
    name: "effective_tax_rate",
    tooltipText: "This percentage is calculated automatically based on your income and deductions. It represents the actual percentage of your total income that goes to the IRS. Unlike your tax bracket, which only applies to the top portion of your income, this rate gives you a realistic view of your overall tax burden.",
  },
  {
    name: "marginal_tax_rate",
    tooltipText: "This rate is calculated automatically based on your current income level. It tells you the percentage of tax you would pay on an additional dollar of income. This is the most important number for planning, as it helps you understand the tax impact of a raise, a bonus, or withdrawing extra money from retirement.",
  },
  {
    name: "total_tax_liability",
    tooltipText: "This is the estimated total dollar amount of taxes you owe for the year, calculated automatically based on the income, filing status, and deductions entered in this form. It represents your \"bottom line\" tax obligation before any payments or withholdings are applied.",
  },
  {
    name: "number_of_dependents",
    tooltipText: "Enter the number of children or other qualifying relatives you claim on your tax return. This number is critical for calculating valuable tax breaks, such as the Child Tax Credit and other family-related deductions, which can significantly lower your total tax liability.",
  },
  {
    name: "w2_gross_income",
    tooltipText: "This field displays your total gross wages for the year. It is automatically populated based on the information you already entered in the Income module. To update this number, please return to the Income module and edit your employment details.",
  },
  {
    name: "self_employment_net_earnings",
    tooltipText: "Enter the net profit from any freelance work, contracting, or small business you own (total income minus business expenses). This figure is essential for calculating self-employment tax and determining your total taxable income.",
  },
  {
    name: "hsa_contributions",
    tooltipText: "Enter the total amount you personally contributed to a Health Savings Account (HSA) this year. Do not include contributions made by your employer. These contributions are typically tax-deductible and reduce your Adjusted Gross Income (AGI).",
  },
  {
    name: "student_loan_interest",
    tooltipText: "Enter the total interest you paid on qualified student loans during the tax year. You may be able to deduct a portion of this interest, which can help lower your taxable income.",
  },
  {
    name: "traditional_ira_contribution",
    tooltipText: "Enter the amount you contributed to a Traditional IRA for the tax year. Depending on your income level and whether you have a retirement plan at work, these contributions may be deductible, reducing your current tax liability.",
  },
  {
    name: "educator_expenses",
    tooltipText: "If you are a qualified teacher or educator (K-12), enter the amount you spent out-of-pocket on classroom supplies and materials. You can deduct a set amount of these expenses to lower your taxable income.",
  },
  {
    name: "net_shortterm_gains",
    tooltipText: "Enter the total profit or loss from assets (like stocks or property) that you held for one year or less. Short-term gains are typically taxed at your ordinary income tax rate.",
  },
  {
    name: "net_longterm_gains",
    tooltipText: "Enter the total profit or loss from assets you held for more than one year. Long-term gains are generally taxed at a lower, preferential tax rate compared to regular income.",
  },
  {
    name: "capital_loss_carryforward",
    tooltipText: "If your capital losses exceeded your capital gains in previous years, you may have \"carried forward\" the excess loss. Enter that amount here to offset current or future gains and potentially reduce your taxable income.",
  },
  {
    name: "child_dependent_care",
    tooltipText: "Enter the total amount you paid for the care of a qualifying child (under 13) or disabled dependent so that you could work or look for work. You may be eligible for a credit based on a percentage of these expenses.",
  },
  {
    name: "qualified_education_expenses",
    tooltipText: "Enter the amount paid for tuition, fees, and other required expenses for higher education for yourself, your spouse, or your dependent. These expenses may qualify you for valuable credits like the American Opportunity Credit or the Lifetime Learning Credit.",
  },
  {
    name: "total_estimated_annual_gross_income",
    tooltipText: "This figure represents your total income from all sources before any taxes or deductions are taken out. It is calculated automatically by summing your W2 income, self-employment earnings, and investment gains.",
  },
  {
    name: "amount_of_credit",
    tooltipText: "Enter the total dollar value of the tax credit. Unlike a tax deduction, which lowers your taxable income, a credit reduces your actual tax bill dollar-for-dollar, making it a powerful tool for lowering your liability.",
  },
  {
    name: "tax_credit_type",
    tooltipText: "Select the specific category for this credit (e.g., Solar Energy, Electric Vehicle, Child Tax Credit). Categorizing this correctly ensures the system applies the credit according to the proper tax rules and limits.",
  },
  {
    name: "whose_credit",
    tooltipText: "Specify which person on the tax return (e.g., Taxpayer, Spouse, or Dependent) generated this credit. This is important for tracking individual contributions to the household's tax strategy.",
  },
  {
    name: "date",
    tooltipText: "Enter the date the eligible expense was incurred or the property was placed in service (e.g., the date you bought the electric vehicle or installed solar panels). This ensures the credit is applied to the correct tax year.",
  },
  {
    name: "description",
    tooltipText: "Add a brief note to provide context for this credit, such as the specific model of equipment purchased or the name of the service provider. This helps you easily identify the entry later.",
  },
  {
    name: "source_asset_sold",
    tooltipText: "Enter the specific name or description of the asset being sold (e.g., \"100 shares of Apple stock,\" \"Rental Property at 123 Main St,\" or \"Vintage Coin Collection\"). This helps identify the transaction for your records.",
  },
  {
    name: "asset_type",
    tooltipText: "Select the category that best describes the asset (e.g., Stock, Real Estate, Collectible). This classification is important because different types of assets may be subject to different tax rules and rates.",
  },
  {
    name: "commission_and_fees",
    tooltipText: "Enter any costs directly associated with the sale, such as broker commissions, legal fees, or closing costs. These expenses typically reduce your total taxable gain, helping to lower your tax liability on the transaction.",
  },
  {
    name: "date_purchase",
    tooltipText: "Enter the original date you acquired the asset. This date is critical for determining whether your gain or loss is considered \"short-term\" (held for one year or less) or \"long-term\" (held for more than one year), which significantly impacts the tax rate applied.",
  },
  {
    name: "purchase_price",
    tooltipText: "Enter the original cost of the asset (also known as your \"cost basis\"). This amount is subtracted from the sale price to determine your actual capital gain or loss. Be sure to include the purchase price plus any original purchase fees or subsequent improvements.",
  },
  {
    name: "date_sold",
    tooltipText: "Enter the date you sold or disposed of the asset. This date is compared with the \"Date Purchase\" to determine if your gain or loss is classified as Short-Term (held one year or less) or Long-Term (held more than one year), which affects your tax rate.",
  },
  {
    name: "sale_price",
    tooltipText: "Enter the total amount you received from the sale of the asset. This figure, minus your original purchase price and any commissions/fees, will be used to calculate your final capital gain or loss for the transaction.",
  },
  //Contacts
  {
    name: "trusted_individual",
    tooltipText: "Select Yes to designate this contact as a Trusted Individual. This is a critical role: this person will have the authority to \"trigger\" the Death plan, officially confirming your passing. Once triggered, the software unlocks your plan, allowing them to access the instructions and documents you have prepared. Only assign this to someone you trust implicitly to handle this responsibility.",
  },
  {
    name: "second_password_granted",
    tooltipText: "This option adds an extra layer of security to your digital legacy. If set to Yes, this Trusted Individual will be granted specific access to the Passwords section of the Death module. This allows them to view the login credentials you have saved. If set to No, they can access the rest of your plan but will remain locked out of your password list.",
  },
  {
    name: "part_of_core_team",
    tooltipText: "Select Yes to identify this contact as a primary support person in the event of your death. This designation helps organize your contacts by separating your essential circle—such as immediate family, executors, or key advisors—from the wider list. It signals to your Trusted Individual that this person should be prioritized for communication and decision-making.",
  },
  //Dashboard, next to "Financial Dashbard" title
  {
    name: "financial_dashboard",
    tooltipText: "Welcome to the command center of your financial platform. This dashboard is designed for total flexibility, allowing you to switch between three unique dashboard views to suit different needs or workflows. You can customize each view by choosing from nearly 20 specialized widgets—including seamless integrations with your Google Calendar and Google Tasks. Simply drag and drop tiles to arrange them exactly how you like. Important: Whenever you make changes to your layout, remember to click the Save Dashboard Setting button to ensure your preferences are stored.",
  },
  //Insurance
  {
    name: "Policy Name (Person(s)/Property Insured)",
    tooltipText: "Enter a descriptive name to help you identify what this policy covers. This could be the specific address of a property, the vehicle name, or the name of the person insured (e.g., \"Primary Residence,\" \"2020 Honda Civic,\ or \John's Term Life\").",
  },
  {
    name: "Owner",
    tooltipText: "Select the legal owner of this insurance policy. This is typically the person named on the contract who is responsible for premium payments and authorized to make changes to the coverage.",
  },
  {
    name: "Policy Start Date",
    tooltipText: "Enter the date the coverage becomes effective. This \"effective date\" is found on your policy declarations page and marks the beginning of the current coverage term.",
  },
  {
    name: "Policy End Date",
    tooltipText: "Enter the expiration date of your current policy term. Tracking this date is vital so you can renew or shop for new rates before your coverage lapses.",
  },
  {
    name: "Insurance Company",
    tooltipText: "Enter the name of the insurance carrier or provider issuing the policy. Having this clearly listed ensures you know exactly which company to contact for claims, billing, or customer service.",
  },
  {
    name: "Policy Number",
    tooltipText: "Enter the unique alphanumeric identifier assigned to your specific policy. You will need this number for essentially all interactions with your insurer, including filing claims and verifying coverage. For security, consider only entering the last four of your policy number. We do not require entire policy numbers.",
  },
  {
    name: "Upload Document",
    tooltipText: "Upload a digital copy of the policy declarations page, contract, or insurance card. Storing the original document here ensures you have immediate access to the full terms, conditions, and proof of coverage whenever you need it.",
  },
  //Auto Insurance
  {
    name: "Liability Coverage",
    modules:["Automobile V2"],
    tooltipText: "Enter the total amount of liability protection provided by this policy. This coverage pays for bodily injury and property damage you cause to others if you are at fault in an accident. It is the most essential part of your policy for protecting your assets from lawsuits.",
  },
  {
    name: "Comprehensive Coverage",
    modules:["Automobile V2"],
    tooltipText: "Enter the limit or deductible for your comprehensive coverage. This pays to repair or replace your vehicle if it is damaged by something other than a collision, such as theft, fire, vandalism, hail, or hitting an animal.",
  },
  {
    name: "Collision Coverage",
    modules:["Automobile V2"],
    tooltipText: "Enter the limit or deductible for your collision coverage. This pays to repair your vehicle if you hit another car or object (like a fence or tree), or if your car rolls over, regardless of who is at fault.",
  },
  {
    name: "Uninsured/Underinsured Motorist Coverage",
    modules:["Automobile V2"],
    tooltipText: "Enter the coverage limit for accidents involving drivers who have no insurance or insufficient coverage. This ensures your medical bills and vehicle repairs are covered if you are hit by a driver who cannot pay for the damage they caused.",
  },
  {
    name: "Personal Injury Protection",
    modules:["Automobile V2"],
    tooltipText: "Enter your Personal Injury Protection limit. Often required in \"no-fault\" states, this covers medical expenses, and in some cases lost wages and funeral costs, for you and your passengers—regardless of who caused the accident.",
  },
  {
    name: "Medical Payment Coverage",
    modules:["Automobile V2"],
    tooltipText: "Enter the limit for Medical Payments (MedPay) coverage. This helps pay for reasonable medical and funeral expenses for you and your passengers after an accident, regardless of fault.",
  },
  {
    name: "Premium",
    modules:["Automobile V2"],
    tooltipText: "Enter the actual dollar amount you pay for this policy.",
  },
  {
    name: "Annual or Monthly",
    modules:["Automobile V2"],
    tooltipText: "Select whether the Premium amount entered above is paid once a year (Annual) or typically paid every month (Monthly). This helps the software accurately calculate your total annual insurance costs.",
  },
  {
    name: "Endorsement",
    modules:["Automobile V2"],
    tooltipText: "Enter any optional add-ons or specific riders attached to your policy that modify your standard coverage. Common automobile endorsements include Roadside Assistance, Rental Car Reimbursement, or Gap Insurance. Listing these ensures you have a record of the \"extras\" that protect you beyond the basic liability and collision limits.",
  },
  {
    name: "Discounts",
    modules:["Automobile V2"],
    tooltipText: "List the specific price reductions currently applied to your premium. Common examples include \"Safe Driver,\" \"Multi-Policy\" (bundling home and auto), or \"Good Student\" discounts. Tracking these helps you verify that you are receiving all the savings you are entitled to when it's time to renew.",
  },
  //Homeowners AND Other Property and Casualty
  {
  name: "Dwelling Coverage",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for Dwelling Coverage. This pays to repair or rebuild the physical structure of your home (the house itself) if it is damaged by a covered peril like fire, wind, or hail.",
  },
  {
  name: "Other Structures",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the coverage limit for structures on your property that are not attached to your main house. This typically includes detached garages, tool sheds, fences, and guest cottages.",
  },
  {
  name: "Personal Property Coverage",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for your belongings. This covers the cost to repair or replace your personal items—such as furniture, electronics, clothing, and appliances—if they are stolen or damaged.",
  },
  {
  name: "Loss of Use Coverage",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for Loss of Use (or Additional Living Expenses). If a covered disaster makes your home uninhabitable, this pays for the extra costs of living elsewhere, such as hotel bills, restaurant meals, and other temporary living expenses.",
  },
  {
  name: "Liability Coverage",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for personal liability protection. This is crucial for protecting your assets if a guest is injured on your property or if you (or a family member) accidentally damage someone else's property and are sued.",
  },
  {
  name: "Medical Payments to Others",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for Medical Payments coverage. This pays for minor medical bills for guests who are injured on your property, regardless of who was at fault. It is often used to resolve small injuries without a lawsuit.",
  },
  {
  name: "Replacement Cost or Cash Value",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the limit for Medical Payments coverage. This pays for minor medical bills for guests who are injured on your property, regardless of who was at fault. It is often used to resolve small injuries without a lawsuit.",
  },
  {
  name: "Deductible",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the dollar amount you are responsible for paying out-of-pocket before your insurance company begins paying on a claim.",
  },
  {
  name: "Premium",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter the actual dollar amount you pay for this policy.",
  },
  {
  name: "Annual or Monthly",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Select whether the Premium amount entered above is paid once a year (Annual) or typically paid every month (Monthly). This helps the software accurately calculate your total annual housing costs.",
  },
  {
  name: "Endorsement",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "Enter any optional add-ons or riders attached to your policy that extend your coverage. Common homeowners endorsements include \"Scheduled Personal Property\" (for high-value items like jewelry or art), \"Water Backup/Sump Pump\" coverage, or \"Service Line\" coverage. Listing these ensures your record reflects the full extent of your protection beyond the standard dwelling limits.",
  },
  {
  name: "Discounts",
  modules:["Homeowners V2","Other Property and Casualty V2"],
  tooltipText: "List the specific price reductions currently applied to your premium. Common examples include \"Multi-Policy\" (bundling home and auto), \"Protective Device\" (for having a security system or smoke detectors), or \"Claims-Free\" discounts. Tracking these helps you verify that you are receiving all the savings you are entitled to when it's time to renew.",
  },
  //Renters
  {
  name: "Personal Property Coverage",
  modules:["Renters V2"],
  tooltipText: "Enter the coverage limit for your personal belongings. Since your landlord's insurance only covers the building itself, this is the portion of the policy that protects your furniture, clothes, electronics, and other items if they are stolen or damaged by a covered event.",
  },
  {
  name: "Liability Coverage",
  modules:["Renters V2"],
  tooltipText: "Enter the limit for personal liability protection. This covers you if you are sued for accidentally injuring someone or damaging their property (e.g., if you accidentally start a kitchen fire that damages a neighbor's apartment).",
  },
  {
  name: "Additional Living Expenses Coverage",
  modules:["Renters V2"],
  tooltipText: "Enter the specific limit for extra daily costs—like hotel bills and restaurant meals—that you would incur if you had to live elsewhere temporarily because your rental was damaged.",
  },
  {
  name: "Medical Payments to Others",
  modules:["Renters V2"],
  tooltipText: "Enter the limit for Medical Payments coverage. This pays for minor medical bills for guests who are injured in your rental unit, regardless of who was at fault. It is often used to resolve small accidents without legal action.",
  },
  {
  name: "Loss of Use Coverage",
  modules:["Renters V2"],
  tooltipText: "Enter the total limit available for \"Loss of Use.\" This is the broader category that often includes Additional Living Expenses. It provides financial assistance when your rental unit becomes uninhabitable due to a covered disaster, ensuring you have a place to stay.",
  },
  {
  name: "Deductible",
  modules:["Renters V2"],
  tooltipText: "Enter the dollar amount you are responsible for paying out-of-pocket before your insurance company begins paying on a claim.",
  },
  {
  name: "Premium",
  modules:["Renters V2"],
  tooltipText: "Enter the actual dollar amount you pay for this policy.",
  },
  {
  name: "Annual or Monthly",
  modules:["Renters V2"],
  tooltipText: "Select whether the Premium amount entered above is paid once a year (Annual) or typically paid every month (Monthly).",
  },
  {
  name: "Endorsement",
  modules:["Renters V2"],
  tooltipText: "Enter any optional add-ons to your policy. Common renters endorsements include \"Scheduled Personal Property\" (for expensive items like engagement rings or high-end electronics that exceed standard limits) or \"Pet Damage Liability.\"",
  },
  {
  name: "Discounts",
  modules:["Renters V2"],
  tooltipText: "List any price reductions applied to your premium. Common renters insurance discounts include \"Multi-Policy\" (if you bundle with auto insurance), \"Protective Devices\" (for smoke detectors or burglar alarms), or \"Claims-Free\" discounts.",
  },
  //Health AND Dental AND Vision AND Hearing AND DVH
  {
  name: "Plan Name",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the specific name of this plan as listed on your ID card or enrollment documents (e.g., \"Gold PPO Choice,\" \"Delta Dental Premier,\" or \"VSP Signature\"). This helps distinguish between multiple plans from the same carrier.",
  },
  {
  name: "Type of Health Insurance",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Tooltip: Select the network structure that best describes this plan, such as HMO, PPO, EPO, or HDHP. This classification is important because it dictates whether you need referrals and if you have coverage for out-of-network providers.",
  },
  {
  name: "Annual Deductible - Participating",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the dollar amount you must pay out-of-pocket for services from \"in-network\" providers before your insurance begins to pay. In-network deductibles are typically lower than out-of-network ones.",
  },
  {
  name: "Annual Out of Pocket Maximum - Participating",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the absolute maximum amount you will have to pay in a year for covered services from \"in-network\" providers. Once you reach this limit, the insurance company pays 100% of the allowed amount for the rest of the year.",
  },
  {
  name: "Annual Deductible - Non-Participating",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the dollar amount you must pay before insurance covers services from \"out-of-network\" providers. Many plans have a separate, higher deductible for doctors or facilities that do not have a contract with your insurer.",
  },
  {
  name: "Annual Out of Pocket Maximum - Non-Participating",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the maximum amount you will pay in a year for \"out-of-network\" care. Note that some plans do not have a cap for out-of-network costs, meaning your financial exposure could be unlimited.",
  },
  {
  name: "Prescription Copay",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the fixed dollar amount you pay for a standard prescription fill. If your plan has tiered pricing (e.g., generic vs. brand name), enter the most common copay amount or list the range in the notes.",
  },
  {
  name: "Premium",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the actual dollar amount you pay for this policy. If this is an employer-sponsored plan, enter just the portion that is deducted from your paycheck.",
  },
  {
  name: "Annual or Monthly",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Select whether the Premium entered is deducted/paid once a year (Annual) or every month (Monthly).",
  },
  {
  name: "Primary Care Physician/Pediatrician",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the name of your designated primary provider. Depending on the policy type, this could be your family doctor, primary dentist, or eye care professional.",
  },
  {
  name: "Primary Care Physician Phone Number",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the direct contact number for the provider listed above. Having this saved here ensures you can quickly schedule appointments or reach them in an emergency.",
  },
  {
  name: "Plan Administrator",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the name of the entity that manages the plan's day-to-day operations. This is often the insurance company itself (e.g., Blue Cross, UnitedHealthcare) but could be a third-party administrator for self-funded employer plans.",
  },
  {
  name: "Plan Administrator Phone Number",
  modules:["Health V2","DVH (Dental, Vision, Hearing) V2",],
  tooltipText: "Enter the customer service number for the plan administrator. This is the number you would call for billing questions, prior authorizations, or to check the status of a claim.",
  },
  //Disability
  {
  name: "Short Term or Long Term",
  modules:["Disability V2"],
  tooltipText: "Select whether this is a Short Term policy (typically covering 3-6 months of disability) or a Long Term policy (which kicks in after a longer waiting period and can pay benefits for years or even until retirement). This distinction is critical for understanding when and how long you will be supported.",
  },
  {
  name: "Type of Policy",
  modules:["Disability V2"],
  tooltipText: "Select the specific classification of your coverage. This often refers to definitions like \"Own Occupation\" (pays if you can't do your specific job) versus \"Any Occupation\" (only pays if you can't do any job). It may also refer to whether the policy is private or employer-sponsored.",
  },
  {
  name: "Waiting Period",
  modules:["Disability V2"],
  tooltipText: "Enter the \"elimination period\"—the number of days you must be disabled before your benefits actually begin paying out. Common waiting periods are 7 days for short-term or 90 days for long-term policies. You essentially self-insure during this time.",
  },
  {
  name: "Benefit Period",
  modules:["Disability V2"],
  tooltipText: "Enter the maximum length of time the policy will pay benefits once you are eligible (e.g., \"2 years,\" \"5 years,\" or \"To Age 65\"). This tells you how long your income protection will last if you remain disabled.",
  },
  {
  name: "Coverage Amount",
  modules:["Disability V2"],
  tooltipText: "Enter the monthly benefit amount you would receive if you file a claim. This is usually a percentage of your gross income (e.g., 60%) or a flat monthly dollar amount.",
  },
  {
  name: "Premium",
  modules:["Disability V2"],
  tooltipText: "Enter the actual dollar amount you pay for this policy. If this is an employer-sponsored plan, enter the portion deducted from your paycheck.",
  },
  {
  name: "Annual or Monthly",
  modules:["Disability V2"],
  tooltipText: "Select whether the Premium entered is paid once a year (Annual) or every month (Monthly).",
  },
  {
  name: "Employer Contact Name",
  modules:["Disability V2"],
  tooltipText: "If this is a work-sponsored group policy, enter the name of the HR representative or benefits administrator who manages the plan. You would contact this person to initiate a claim.",
  },
  {
  name: "Employer Contact Phone Number",
  modules:["Disability V2"],
  tooltipText: "Enter the direct phone number for the HR contact or benefits department listed above.",
  },
  {
  name: "Exclusions",
  modules:["Disability V2"],
  tooltipText: "List any specific conditions or circumstances that are not covered by this policy. Common exclusions might include pre-existing conditions, injuries from high-risk hobbies (like skydiving), or self-inflicted injuries. Knowing these helps you understand the gaps in your protection.",
  },
//Long-term Care
  {
    name: "Home Health Care/Assisted Living Care/Nursing Home Care",
    modules:["Long Term Care V2"],
    tooltipText: "Select Yes if this policy provides comprehensive coverage across all care settings, including care in your own home, assisted living facilities, and skilled nursing homes.",
  },
  {
    name: "Standalone LTC or Linked-Benefit LTC",
    modules:["Long Term Care V2"],
    tooltipText: "Select Yes if this is a \"Standalone\" policy dedicated solely to long-term care. If this is a \"Linked-Benefit\" or \"Hybrid\" policy (e.g., a life insurance policy or annuity that includes a long-term care rider), select the appropriate option. This distinction matters because linked benefits often provide a return of premium or death benefit if the care is never needed.",
  },
  {
    name: "Waiting/Elimination Period",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the number of days you must pay for your own care before the insurance benefits begin (e.g., 90 days). Think of this as the \"deductible\" expressed in time rather than dollars.",
  },
  {
    name: "Benefit Amount",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the maximum daily or monthly dollar amount the policy will pay for your care (e.g., \"$150/day\" or \"$4,500/month\").",
  },
  {
    name: "Death Benefit Amount (if Linked-Benefit)",
    modules:["Long Term Care V2"],
    tooltipText: "If this is a hybrid policy, enter the death benefit amount that would be paid to your beneficiaries if you pass away without using the long-term care benefits.",
  },
  {
    name: "Benefit Period",
    modules:["Long Term Care V2"],
    tooltipText: "Enter how long the benefits will last once they begin (e.g., \"3 Years,\" \"5 Years,\" or \"Lifetime\").",
  },
  {
    name: "Lifetime Maximum",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the total \"pool of money\" available in the policy. This is often calculated by multiplying your daily benefit by the benefit period (e.g., $150/day x 3 years).",
  },
  {
    name: "Inflation Protection %",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the percentage rate at which your benefit amount grows each year to keep up with the rising cost of healthcare (e.g., \"3% Compound\" or \"5% Simple\"). This is crucial for maintaining the value of your coverage over decades.",
  },
  {
    name: "Rider Notes",
    modules:["Long Term Care V2"],
    tooltipText: "Use this field to document any special riders or unique features of the policy, such as \"Shared Care\" (which allows spouses to share their benefit pools) or \"Return of Premium\" riders.",
  },
  {
    name: "Indemnity or Reimbursement",
    modules:["Long Term Care V2"],
    tooltipText: "Select Indemnity if the policy pays a fixed cash benefit directly to you regardless of your actual expenses (giving you flexibility to pay family caregivers). Select Reimbursement if the policy pays the care provider directly or reimburses you only for actual qualified receipts.",
  },
  {
    name: "Guaranteed Renewable",
    modules:["Long Term Care V2"],
    tooltipText: "Select Yes if the policy includes a provision that prevents the insurance company from canceling your coverage as long as you pay the premiums, regardless of changes in your health.",
  },
  {
    name: "Waiver of Premium",
    modules:["Long Term Care V2"],
    tooltipText: "Select Yes if the policy allows you to stop paying premiums once you are receiving benefits (e.g., after the elimination period). This is a valuable feature that prevents the policy from lapsing when you are most vulnerable.",
  },
  {
    name: "Third Party Notification Name",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the name of a friend, relative, or advisor you have designated to receive notice if your policy is about to lapse due to non-payment. This safeguard helps prevent you from accidentally losing coverage due to forgetfulness or illness.",
  },
  {
    name: "Premium",
    modules:["Long Term Care V2"],
    tooltipText: "Enter the actual dollar amount you pay for this policy.",
  },
  {
    name: "Annual or Monthly",
    modules:["Long Term Care V2"],
    tooltipText: "Select whether the Premium entered is paid once a year (Annual) or every month (Monthly).",
  },
  //Annuity
  {
    name: "Annuitant",
    modules:["Annuity V2"],
    tooltipText: "Enter the name of the person whose life expectancy determines the annuity payments. While this is often the owner, it can be a different person (e.g., a spouse).",
  },
  {
    name: "Type",
    modules:["Annuity V2"],
    tooltipText: "Select the specific category of this annuity (e.g., Fixed, Variable, Fixed Index, or Immediate). This classification is important because it determines how your interest is credited and the level of risk involved.",
  },
  {
    name: "Balance",
    modules:["Annuity V2"],
    tooltipText: "Enter the current total dollar value of the annuity. This is typically the same as the \"Accumulation Value\"—the full amount currently held in the contract, including all premiums paid and interest earned, before any surrender charges or penalties are deducted. This figure is generally used for your Net Worth statement.",
  },
  {
    name: "Accumulation Value (Account Value)",
    modules:["Annuity V2"],
    tooltipText: "Enter the total current value of your annuity contract. This is essentially the \"paper value\" of your investment before any surrender charges or adjustments are applied.",
  },
  {
    name: "Cash Surrender Value",
    modules:["Annuity V2"],
    tooltipText: "Enter the amount you would actually receive if you cancelled the policy today. This is typically the Accumulation Value minus any penalties (surrender charges) for early withdrawal.",
  },
  {
    name: "Death Benefit Value",
    modules:["Annuity V2"],
    tooltipText: "Enter the amount your beneficiaries would receive if you passed away today. In many annuities, this amount is guaranteed to be at least the total premiums you paid, even if the market value has dropped.",
  },
  {
    name: "Lifetime Income Value",
    modules:["Annuity V2"],
    tooltipText: "If your policy has an income rider, enter the \"Income Base\" or \"Benefit Base\" value here. Note that this number is used only to calculate your guaranteed lifetime income checks and usually cannot be taken as a lump sum cash withdrawal.",
  },
  {
    name: "Surrender Period",
    modules:["Annuity V2"],
    tooltipText: "Enter the number of years the surrender schedule lasts or the specific date it ends. This tells you how long you are locked into the contract before you can withdraw your money penalty-free.",
  },
  {
    name: "Surrender Charge",
    modules:["Annuity V2"],
    tooltipText: "Enter the specific dollar penalty or percentage fee you would be charged for withdrawing funds right now.",
  },
  {
    name: "Surrender Notes",
    modules:["Annuity V2"],
    tooltipText: "Use this field to add details about the schedule, such as how much the penalty decreases each year (e.g., \"10% year 1, 9% year 2...\").",
  },
  {
    name: "Qualified or Non-Qualified",
    modules:["Annuity V2"],
    tooltipText: "Select Qualified if the annuity is held inside a retirement account (like an IRA) using pre-tax dollars. Select Non-Qualified if it was purchased with after-tax savings. This distinction dictates how your future withdrawals will be taxed.",
  },
  {
    name: "Agent Commission",
    modules:["Annuity V2"],
    tooltipText: "Enter the amount or percentage paid to the agent who sold you the policy. Recording this can provide transparency regarding the costs embedded in the contract.",
  },
  {
    name: "Living Rider Notes",
    modules:["Annuity V2"],
    tooltipText: "Document details about any optional \"Living Benefits\" attached to your policy, such as guaranteed income riders or long-term care doublers.",
  },
  {
    name: "Death Benefit Rider Notes",
    modules:["Annuity V2"],
    tooltipText: "Document details about any enhanced death benefits, such as spousal continuation rights or \"step-ups\" that lock in market gains for your heirs.",
  },
  {
    name: "Premium",
    modules:["Annuity V2"],
    tooltipText: "Enter the amount you contributed to start the annuity.",
  },
  {
    name: "Annual / Monthly / One-Time",
    modules:["Annuity V2"],
    tooltipText: "Select the frequency of your payments. Since many annuities are funded with a single lump sum transfer, One-Time is a common choice here.",
  },
  //Whole Life AND Other Life and Health
  {
    name: "Person Insured",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Enter the name of the individual whose life is covered by this policy. Upon their passing, the death benefit will be paid out.",
  },
  {
    name: "Type",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Select the specific category of permanent life insurance. For this form, you would typically select Whole Life, but this field may also support Universal Life or Variable Life distinctions.",
  },
  {
    name: "Benefit Amount",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Enter the \"Face Amount\" of the policy. This is the guaranteed death benefit that will be paid to your beneficiaries when the insured person passes away.",
  },
  {
    name: "Premium",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Enter the actual dollar amount you pay to keep the policy active. For Whole Life, this premium is typically fixed for the life of the policy.",
  },
  {
    name: "Annual or Monthly",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Select whether the Premium entered is paid once a year (Annual) or every month (Monthly).",
  },
  {
    name: "Cash Value",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Enter the current accumulated savings value of the policy. Unlike term insurance, whole life policies build distinct equity over time that you can borrow against tax-free or receive as cash if you choose to surrender the policy.",
  },
  {
    name: "Rider Notes",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Use this field to list any specific add-ons attached to your policy. Common riders for whole life include \"Waiver of Premium\" (pays your premium if you become disabled) or \"Guaranteed Insurability\" (allows you to buy more coverage later without a medical exam).",
  },
  {
    name: "Add Beneficiaries",
    modules:["Whole Life V2","Other Life and Health V2"],
    tooltipText: "Enter the names of the individuals or organizations who will receive the death benefit. Be sure to specify the Percent for each if you are splitting the money between multiple people (e.g., 50% to Spouse, 50% to Children).",
  },
  //Term
  {
    name: "Person Insured",
    modules:["Term V2"],
    tooltipText: "Enter the name of the individual whose life is covered by this policy. If this person passes away during the specific term of the policy, the death benefit will be paid out.",
  },
  {
    name: "Type",
    modules:["Term V2"],
    tooltipText: "Select the specific category of term insurance. This might be \"Level Term\" (where premiums stay the same for the whole period) or \"Annual Renewable Term\" (where premiums increase every year).",
  },
  {
    name: "Term Length",
    modules:["Term V2"],
    tooltipText: "Enter the duration of the coverage (e.g., \"10 Years,\" \"20 Years,\" or \"30 Years\"). Unlike permanent insurance, this policy will expire after this set period, often requiring you to renew at a much higher rate or purchase a new policy.",
  },
  {
    name: "Benefit Amount",
    modules:["Term V2"],
    tooltipText: "Enter the \"Face Amount\" of the policy. This is the lump sum dollar amount that your beneficiaries will receive tax-free if you pass away while the policy is active.",
  },
  {
    name: "Premium",
    modules:["Term V2"],
    tooltipText: "Enter the actual dollar amount you pay to maintain this coverage.",
  },
  {
    name: "Annual or Monthly",
    modules:["Term V2"],
    tooltipText: "Select whether the Premium entered is paid once a year (Annual) or every month (Monthly).",
  },
  {
    name: "Rider Notes",
    modules:["Term V2"],
    tooltipText: "Use this field to document any special add-ons to your policy. Common term life riders include \"Return of Premium\" (which refunds your payments if you outlive the term) or \"Child Term Riders\" (which provide small coverage amounts for your children).",
  },
  {
    name: "Add Beneficiaries",
    modules:["Term V2"],
    tooltipText: "Enter the names of the individuals (primary and contingent) who will receive the death benefit. Be sure to specify the Percent allocated to each person to ensure the payout is distributed exactly according to your wishes.",
  },
  //Fire AND Earthquake AND Flood AND Specialty
  {
    name: "Personal Property Coverage Amount",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Enter the maximum dollar amount this policy will pay to replace your belongings (furniture, electronics, clothing) if they are damaged by the specific peril (e.g., flood, earthquake, or fire). Note that standard homeowner policies often exclude or strictly limit coverage for these specific disasters, making this separate limit crucial.",
  },
  {
    name: "Additional Living Expense Coverage Amount",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Enter the limit for \"Loss of Use\" expenses. If a covered disaster makes your home uninhabitable, this pays for the extra costs of living elsewhere, such as hotel bills, restaurant meals, and temporary rentals, while your home is being repaired.",
  },
  {
    name: "Deductible",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Enter the amount you must pay out-of-pocket before insurance kicks in. Important: For Earthquake and Flood policies, this is often a percentage of your dwelling coverage (e.g., 10% or 15%) rather than a flat dollar amount, which can result in a much higher out-of-pocket cost than a standard policy.",
  },
  {
    name: "Policy Inclusion Notes",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Use this field to list specific items or structures that are explicitly covered by this policy to avoid confusion later. For example, verify if your Earthquake policy covers \"masonry veneer\" or if your Flood policy covers the \"contents of a basement,\" and note it here.",
  },
  {
    name: "Policy Exclusion Notes",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "List the significant events or property types that are not covered. For example, a Flood policy typically excludes moisture or mold damage that wasn't directly caused by a flood event, and Earthquake policies often exclude damage to pools or fences.",
  },
  {
    name: "Premium",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Enter the actual dollar amount you pay for this specific policy.",
  },
  {
    name: "Annual or Monthly",
    modules:["Fire V2","Earthquake V2","Flood V2","Specialty and Misc V2"],
    tooltipText: "Select whether the Premium amount entered above is paid once a year (Annual) or typically paid every month (Monthly).",
  },
  //Medicare WHEN Medicare Type = Medicare Advantage
  {
    name: "Medicare Type",
    modules:["Medicare V2"],
    tooltipText: "Select the fundamental structure of your coverage. Choose Original Medicare if you have the traditional federal program (Part A & B), often paired with a separate Medigap policy. Choose Medicare Advantage (Part C) if you have opted for a bundled, \"all-in-one\" private plan that replaces Original Medicare.",
  },
  {
    name: "Annual / Monthly / One-Time",
    modules:["Medicare V2"],
    tooltipText: "Select how often you pay your premium. For many retirees, Medicare Part B premiums are deducted Monthly directly from their Social Security checks. If you are not yet collecting Social Security, you may be billed quarterly (which you can annualize) or monthly. Accurate selection here ensures your total annual healthcare costs are calculated correctly.",
  },
  {
    name: "Part B (Medical Insurance) Premium",
    modules:["Medicare V2"],
    tooltipText: "Enter your standard federal Medicare Part B premium. Important: Even with a Medicare Advantage plan, you typically must continue paying this base federal premium (usually deducted from Social Security) to keep your coverage active.",
  },
  {
    name: "Part C (Medicare Advantage) Carrier",
    modules:["Medicare V2"],
    tooltipText: "Enter the name of the private insurance company providing this plan (e.g., UnitedHealthcare, Humana, Aetna, or Kaiser Permanente).",
  },
  {
    name: "Part C (Medicare Advantage) Plan Name",
    modules:["Medicare V2"],
    tooltipText: "Enter the specific marketing name of your plan (e.g., \"Gold Plus HMO\" or \"Choice PPO\"). This distinguishes your specific package from others offered by the same carrier.",
  },
  {
    name: "Part C (Medicare Advantage) Network Type",
    modules:["Medicare V2"],
    tooltipText: "Select HMO if your plan requires you to use a specific network of doctors and get referrals for specialists. Select PPO if your plan offers more flexibility to see out-of-network doctors, usually at a higher cost, without referrals.",
  },
  {
    name: "Part C (Medicare Advantage) Monthly Premium",
    modules:["Medicare V2"],
    tooltipText: "Enter the additional monthly premium you pay directly to the insurance carrier for this plan. Note: Many Advantage plans have a $0 premium, but if yours has a cost, enter it here.",
  },
    {
    name: "Part C (Medicare Advantage) Policy ID",
    modules:["Medicare V2"],
    tooltipText: "Enter the member ID number found on your Medicare Advantage card. You will need this number for all appointments and pharmacy visits.",
  },
    {
    name: "Part C (Cost Structure) Annual Medicaid Deductible",
    modules:["Medicare V2"],
    tooltipText: "Enter the dollar amount you must pay out-of-pocket for medical services before your plan begins to pay. (Note: Some plans have a $0 medical deductible).",
  },
  {
    name: "Part C (Cost Structure) Maximum Out of Pocket",
    modules:["Medicare V2"],
    tooltipText: "Enter the absolute maximum amount you will have to pay for covered medical services in a year. This is your financial safety net—once you reach this limit, the plan pays 100% of covered costs for the rest of the year.",
  },
  {
    name: "Part C (Cost Structure) Primary Care Physician Copay",
    modules:["Medicare V2"],
    tooltipText: "Enter the fixed dollar amount you pay for a standard office visit with your primary doctor.",
  },
  {
    name: "Part C (Cost Structure) Specialist Copay",
    modules:["Medicare V2"],
    tooltipText: "Enter the fixed dollar amount you pay for a visit to a specialist (e.g., cardiologist, dermatologist).",
  },
  {
    name: "Part C (Prescription Drug Details) Include Drug Coverage",
    modules:["Medicare V2"],
    tooltipText: "Select Yes if this plan includes prescription drug coverage (often called an \"MAPD\" plan). Select No if this plan covers medical only.",
  },
  {
    name: "Part C (Prescription Drug Details) Annual Drug Deductible",
    modules:["Medicare V2"],
    tooltipText: "Enter the specific deductible that applies to medications. This is often separate from your medical deductible and must be met before the plan shares the cost of your prescriptions.",
  },
    //Medicare WHEN Medicare Type = Original Medicare
  {
    name: "Part A (Hospital Insurance) Premium",
    modules:["Medicare V2"],
    tooltipText: "Enter your monthly premium for Part A (Hospital Insurance). Note: For most people who have worked and paid Medicare taxes for at least 10 years, this amount is $0. Only enter a dollar amount here if you do not qualify for premium-free Part A.",
  },
  {
    name: "Part A Deductible (Per Benefit Period)",
    modules:["Medicare V2"],
    tooltipText: "Enter the deductible amount you must pay before Original Medicare starts covering your hospital stay. Note that unlike standard annual deductibles, this applies per benefit period (meaning you could pay it more than once a year if you have multiple separate hospitalizations).",
  },
    {
    name: "Part B (Medical Insurance) Premiums",
    modules:["Medicare V2"],
    tooltipText: "Enter the standard monthly premium for Part B (Medical Insurance). For most retirees, this is automatically deducted from their Social Security check.",
  },
  {
    name: "Part B (Medical Insurance) Deductible",
    modules:["Medicare V2"],
    tooltipText: "Enter the annual deductible for Part B. You must pay this amount out-of-pocket for doctor visits and outpatient care before Medicare begins to pay its share (typically 80%).",
  },
  {
    name: "Medigap Supplement Plan Carrier",
    modules:["Medicare V2"],
    tooltipText: "Enter the name of the private insurance company that provides your Medigap policy (e.g., AARP/UnitedHealthcare, Mutual of Omaha, Blue Cross).",
  },
  {
    name: "Medigap Supplement Plan Type",
    modules:["Medicare V2"],
    tooltipText: "Enter the specific \"Letter\" plan you are enrolled in (e.g., Plan G, Plan N, or Plan F). This letter is the most important detail, as it strictly defines exactly which co-pays and deductibles the policy covers.",
  },
  {
    name: "Medigap Supplement Plan Monthly Premium",
    modules:["Medicare V2"],
    tooltipText: "Enter the monthly amount you pay directly to the private carrier for this extra coverage.",
  },
  {
    name: "Medigap Supplement Plan Policy ID",
    modules:["Medicare V2"],
    tooltipText: "Enter the Member ID found on your Medigap insurance card.",
  },
  {
    name: "Part D (Prescription Drug Plan) Carrier",
    modules:["Medicare V2"],
    tooltipText: "Enter the name of the private insurance company that manages your drug coverage (e.g., SilverScript, Humana, WellCare).",
  },
  {
    name: "Part D (Prescription Drug Plan) Plan Name",
    modules:["Medicare V2"],
    tooltipText: "Enter the specific name of the drug plan (e.g., \"Value Script\" or \"Premier Rx\"). This helps distinguish between the budget and comprehensive options offered by the same carrier.",
  },
  {
    name: "Part D (Prescription Drug Plan) Monthly Premium",
    modules:["Medicare V2"],
    tooltipText: "Enter the monthly premium you pay for this drug plan. This is separate from your Part B premium.",
  },
  {
    name: "Part D (Prescription Drug Plan) Annual Deductible",
    modules:["Medicare V2"],
    tooltipText: "Enter the amount you must pay for medications each year before your drug plan begins to pay.",
  },
  {
    name: "Part D (Prescription Drug Plan) Policy ID",
    modules:["Medicare V2"],
    tooltipText: "Enter the Member ID found on your prescription drug card. You will need this number when filling prescriptions at the pharmacy.",
  },
  //Umbrella
  {
    name: "Overall Policy Limit",
    modules:["Umbrella V2"],
    tooltipText: "Enter the total coverage amount provided by this umbrella policy (e.g., $1,000,000 or $5,000,000). This is the maximum amount the insurance company will pay for liability claims after your underlying auto or homeowners limits have been exhausted.",
  },
  {
    name: "Self-Insured Retention (SIR)",
    modules:["Umbrella V2"],
    tooltipText: "Enter the SIR amount. This acts like a deductible for your Umbrella policy. It is the dollar amount you must pay out-of-pocket before the Umbrella policy responds to a claim that isn't covered by your underlying primary insurance policies.",
  },
  {
    name: "Premium",
    modules:["Umbrella V2"],
    tooltipText: "This amount is calculated automatically based on the \"Monthly Premium\" column in the Insurance Policies Under Umbrella table below. It represents the total premium derived from the policies you have currently linked to this umbrella plan. To adjust this figure, please add or remove policies in the table.",
  },
  {
    name: "Annual or Monthly",
    modules:["Umbrella V2"],
    tooltipText: "Select whether the Premium entered is paid once a year (Annual) or every month (Monthly).",
  },
  {
    name: "Insurance Policies Under Umbrella",
    modules:["Umbrella V2"],
    tooltipText: "This table lists the active policies (like Auto or Homeowners) that are currently linked to this Umbrella plan. These are your \"primary\" policies that must pay their full limits before the Umbrella coverage kicks in. Review this list to ensure all required underlying policies are attached.",
  },
  {
    name: "Insurance Policies Selection",
    modules:["Umbrella V2"],
    tooltipText: "This table displays every insurance policy you have entered into the system that is eligible to be linked. Use this list to find and \"Select\" the specific Auto, Home, or Boat policies that act as the base layer for your Umbrella coverage.",
  },
  //Manage Secure Links module
  {
    name: "Manage Secure Links",
    tooltipText: "Use this dashboard to track and manage the documents you have shared via secure, time-sensitive URLs. Here, you can copy an active link to resend it or delete a row to immediately revoke access before the expiration time is reached. Note: Deleting a link here only stops the sharing function; it does not delete the original document from your file storage.",
  },
  {
    name: "Refresh Budget Transactions",
    tooltipText: (
      <div>
        <p>
          Triggers a recalculation of the dashboard view by re-fetching data from the Asset Planet database based on your currently applied filters. This action updates the visual summaries and transaction lists to reflect any recent manual edits, category changes, or specific date ranges you have selected.
        </p>
        <ul style={{ paddingLeft: "18px", margin: 0 }}>
          <li>
            <strong>Note:</strong> This button re-queries existing records within our system; it does not initiate a real-time communication or "sync" with your linked financial institutions via Plaid. For example, if you just manually assigned a new category to a group of transactions and the dashboard totals haven't updated yet, clicking this will force the module to display those updated calculations.
          </li>
        </ul>
      </div>
    ),
  },
  {
    name: "Link Bank",
    tooltipText: (
      <div>
        <p>
          Securely connect your financial institutions via Plaid to automate your financial tracking.
        </p>
        <ul style={{ paddingLeft: "18px", margin: 0 }}>
          <li>
            <strong>Adding Banks:</strong> Click Add Bank to search for your institution. 
            Specify if it holds Assets, Liabilities, or Both.
          </li>
          <li>
            <strong>Match Found:</strong> If a connected account matches the last 4 digits
            of an entry you manually added, it will be flagged as a “Match”.
          </li>
          <li>
            <strong>Add to Asset Planet:</strong> Click Add to import the account. 
            The button disappears once live.
          </li>
          <li>
            <strong>Status & Security:</strong> We never view or store full account numbers.
            A yellow triangle indicates a connection error.
          </li>
          <li>
            <strong>Manage:</strong> Use Refresh to pull balances or the three-dot menu
            to disconnect accounts.
          </li>
        </ul>
      </div>
    ),
  },
  //Debt Payoff module
  {
    name: "Highest Interest First",
    tooltipText: "Select this strategy to pay off debts with the highest interest rates first. Mathematically, this method saves you the most money over time because it eliminates the most expensive debt quickest.",
  },
  {
    name: "Lowest Balance First",
    tooltipText: "Select this strategy to pay off your smallest debts first, regardless of interest rate. This method is designed to build psychological momentum by giving you quick \"wins\" as you eliminate individual accounts faster.",
  },
  {
    name: "Monthly Extra",
    tooltipText: "Enter the additional amount you can commit to paying above your required minimum payments every month. This \"accelerator\" money is applied directly to your target debt (based on your chosen strategy) to reduce your principal faster.",
  },
  {
    name: "One-time Funding",
    tooltipText: "Click to add irregular income events, such as annual work bonuses, tax refunds, or the sale of an asset. These lump sums are injected into your payoff plan on the specific date you choose, drastically cutting down your interest and timeline.",
  },
  {
    name: "Original Debt Free",
    tooltipText: "Original shows when you would be debt-free if you only paid the minimums. New shows your accelerated date based on the \"Monthly Extra\" and \"One-Time Funding\" you have added to this plan.",
  },
  {
    name: "Time Saved 🎉",
    tooltipText: "These green highlights quantify the value of your plan. They show exactly how many years you are shaving off your debt sentence and the total cash you are keeping in your pocket instead of paying to the bank.",
  },
  {
    name: "Snowball",
    tooltipText: "This column represents your total \"power payment\" for that month. It combines your Monthly Extra contribution plus the minimum payments from any debts you have already paid off. As debts are eliminated, this amount grows (like a snowball), allowing you to attack the remaining debts with increasing force.",
  },
  {
    name: "End Balance",
    tooltipText: "This shows your total remaining debt load across all liabilities at the end of each month. Watch this number decrease faster as your \"Snowball\" amount increases.",
  },
  //Social Security module
  {
    name: "Your Monthly Benefit at FRA ($)",
    tooltipText: "Enter the estimated monthly benefit amount you are scheduled to receive at your \"Full Retirement Age\" (typically age 66 or 67, depending on your birth year). You can find this specific number on your official Social Security Statement (available at ssa.gov). Note: Do not enter your age-62 or age-70 estimates here; the software needs the FRA baseline to calculate the others correctly.",
  },
  {
    name: "Your Estimated Year of Death",
    tooltipText: "Enter a projected year for life expectancy. While difficult to predict, this input is essential for calculating the \"Total Lifetime Benefit\"—the cumulative amount of money you (and your spouse) will collect from the system over your entire retirement. A longer life expectancy generally favors delaying benefits.",
  },
  {
    name: "Your Desired Claim Age",
    tooltipText: "Enter the age you plan to begin receiving checks. Remember: Claiming as early as 62 results in permanently reduced payments, while delaying past your Full Retirement Age (up to age 70) earns you \"Delayed Retirement Credits\" that significantly increase your monthly check.",
  },
  {
    name: "Tax Filing Status",
    tooltipText: "Select how you file your taxes (e.g., Married Filing Jointly or Single). This selection is critical because the income thresholds for taxing Social Security benefits differ significantly based on your filing status.",
  },
  {
    name: "Other Annual Retirement Income ($)",
    tooltipText: "Enter your expected annual income from non-Social Security sources (such as pensions, 401(k) withdrawals, or part-time wages). This figure is used to calculate your \"Provisional Income,\" which determines whether your Social Security benefits will be tax-free, 50% taxable, or 85% taxable.",
  },
  {
    name: "Discount Rate (TVM, %)",
    tooltipText: "Enter the \"Time Value of Money\" percentage used to calculate the \"Present Value\" of your benefits. This allows you to compare the value of future dollars in today's terms. A common default is between 2% and 4% (often reflecting expected inflation or a conservative rate of return on cash).",
  },
  {
    name: "Eligible for WEP/GPO?",
    tooltipText: "Select Yes if you receive a pension from work where you did not pay Social Security taxes (e.g., certain federal, state, or local government jobs, or foreign employment). This triggers the Windfall Elimination Provision or Government Pension Offset rules, which may reduce your Social Security benefit to prevent \"double-dipping.\"",
  },
  {
    name: "WEP/GPO Pension Amount ($)",
    tooltipText: "Enter the gross monthly amount of your non-covered pension. The software uses this figure to calculate exactly how much the WEP or GPO formulas will reduce your standard Social Security benefit.",
  },
  {
    name: "Do you have eligible dependent children?",
    tooltipText: "Select Yes if you have unmarried children who are under age 18 (or up to 19 if still in high school) or children who became disabled before age 22. These dependents may be eligible for additional benefits based on your earnings record.",
  },
  {
    name: "Number of Dependent Children",
    tooltipText: "Enter the total count of eligible children. This helps calculate the \"Family Maximum\"—the cap on the total amount of benefits your family can receive based on your work record.",
  },
  {
    name: "child_date_of_birth",
    tooltipText: "Enter the birth date for each child. This allows the software to determine exactly when their eligibility for benefits will end (typically when they turn 18 or graduate high school).",
  },
  {
    name: "Were you in a prior marriage lasting 10+ years?",
    tooltipText: "Select Yes if you are currently divorced but were married to an ex-spouse for at least 10 consecutive years. If you have not remarried, you may be eligible to claim benefits on your ex-spouse's record if it provides a higher payment than your own. Note: This does not affect your ex-spouse's benefits or their current family.",
  },
  {
    name: "Ex-Spouse Date of Birth",
    tooltipText: "Enter your ex-spouse's birth date. To claim benefits on their record, they generally must be at least 62 years old.",
  },
  {
    name: "Ex-Spouse Estimated Monthly Benefit ($)",
    tooltipText: "Enter the estimated benefit amount your ex-spouse is entitled to at their Full Retirement Age. You are typically entitled to up to 50% of this amount if it is higher than your own worker benefit.",
  },
  {
    name: "Do you have military service credits (1957-2001)?",
    tooltipText: "Select Yes if you served on active duty between 1957 and 2001. During these years, special extra earnings credits were often added to military records to boost future Social Security benefits. (Note: Service after 2001 is already credited as standard wages).",
  },
  {
    name: "Enter date you would like to begin receiving benefits",
    tooltipText: "Enter the specific date you plan to start your Social Security payments. This is critical because the earnings test rules are stricter if you are under your Full Retirement Age (FRA) for the entire year versus the year you actually reach your FRA.",
  },
  {
    name: "Your Estimated Earnings",
    tooltipText: "Enter your expected gross wages or net self-employment income for the year. Do not include investment income, pensions, or interest. This number is tested against the annual limit (e.g., $22,320 for 2024) to see if $1 of benefits will be withheld for every $2 you earn above that limit.",
  },
  {
    name: "Check here if you had years of active military service after 1956",
    tooltipText: "Select Yes if you had active duty service after 1956. This ensures any special wage credits associated with that service are considered when evaluating your record, though for the earnings test specifically, it mostly serves to verify your work history status.",
  },
  {
    name: "calculate",
    tooltipText: "Click to run the test. The software will determine if your estimated earnings are high enough to temporarily reduce or suspend your Social Security checks for this year.",
  },
  //Chat module
  {
    name: "invite_user",
    tooltipText: "Click to search for and connect with other registered Asset Planet users. You must send an invite—and have it accepted—before you can start a private conversation.",
  },
  {
    name: "chat_invite_tabs",
    tooltipText: "Use these tabs to toggle between your active conversations (Chats) and pending connection requests (Invites). The red notification badge indicates how many new messages or requests require your attention.",
  },
  {
    name: "download_chat",
    tooltipText: "Click to export the current conversation history as a PDF file for your records. Note: To ensure fast processing, this download is limited to the most recent 2,000 messages within a conversation.",
  },
  {
    name: "type_your_message_here",
    tooltipText: "Enter your message here. As you type, our system actively scans for compliance-sensitive words (such as \"Guarantee\" or \"Promise\") and highlights them in Red. This is a visual alert to help you maintain professional standards; it does not prevent you from sending the message.",
  },
  {
    name: "read_receipt",
    tooltipText: "A double checkmark indicates that your message has been successfully delivered and viewed by the recipient.",
  },
  {
    name: "retirement_plan_confidence",
    tooltipText: "This percentage represents your 'Plan Confidence Score.' It is calculated by dividing your projected assets at retirement by the total goal target needed to fund your desired lifestyle. A score of 100% or higher indicates you are fully on track.",
  },
  {
    name: "retirement_safety_margin",
    tooltipText: "The safety margin measures how many 'extra' years your portfolio is projected to last beyond your planned life expectancy. A positive number (e.g. +5.2 yrs) provides a buffer against market volatility or living longer than expected.",
  },
  {
    name: "retirement_plan_health",
    tooltipText: "Plan health is a high-level status indicator based on your confidence score. 'On Track' (95%+), 'Viable' (75-94%), and 'Action Required' (<75%) help you quickly identify if you need to adjust your savings or retirement age.",
  },
  //Retirement Goal
  {
    name: "Description of Goal",
    modules:["Retirement"],
    tooltipText: "Give your retirement vision a name (e.g., \"Main Retirement\" or \"Early Exit\"). This helps distinguish this strategy from other potential \"What-If\" scenarios.",
  },
  {
    name: "Current Age",
    modules:["Retirement"],
    tooltipText: "This is your current age as of today. Note: This value is pulled from the Social Security module. Please ensure that module is completed first for the most accurate projection.",
  },
  {
    name: "Spouse's Current Age",
    modules:["Retirement"],
    tooltipText: "Your spouse's current age. Note: This value is synced from the Social Security module. We recommend completing that section first to ensure your joint timeline is correct.",
  },
  {
    name: "Client Life Expectancy",
    modules:["Retirement"],
    tooltipText: "The age to which you want to plan your income. While many plan to age 90 or 95, choosing a later age provides a more conservative \"buffer\" for your wealth path.",
  },
  {
    name: "Spouse Life Expectancy",
    modules:["Retirement"],
    tooltipText: "The age to which you want to plan for your spouse’s income needs. This is critical for calculating survivor benefits and long-term legacy goals.",
  },
  {
    name: "State of Residence in Retirement",
    modules:["Retirement"],
    tooltipText: "Determines the state income tax applied to your retirement distributions. Note: This defaults to the data in your Tax and Inflation module. Complete that module first to ensure local tax nuances are factored into your \"What-If\" analysis.",
  },
  {
    name: "Desired Retirement Age",
    modules:["Retirement"],
    tooltipText: "The age at which you intend to stop working and begin relying on your portfolio and Social Security for income.",
  },
  {
    name: "Spouse's Desired Retirement Age",
    modules:["Retirement"],
    tooltipText: "The age at which your spouse intends to retire. This allows the model to accurately account for staggered retirement dates and changes in household cash flow.",
  },
  {
    name: "Simple and Advanced",
    modules:["Retirement"],
    tooltipText: "Choose Simple to enter one total annual budget figure, or Advanced to break your spending down into specific categories for a more granular and accurate projection.",
  },
  {
    name: "Net Annual Pre-Retirement Budget",
    modules:["Retirement"],
    tooltipText: "This is the sum of your categorized expenses in \"today's dollars.\" It represents the actual lifestyle cost you want to fund before inflation is applied.",
  },
  {
    name: "Inflation rate for this goal",
    modules:["Retirement"],
    tooltipText: "Select the annual rate at which you expect these costs to rise. Note: The options in this dropdown are pulled from the Tax and Inflation module. Please complete that module first to ensure your customized inflation assumptions are available here.",
  },
  {
    name: "Net Amount Needed in Future with Inflation",
    modules:["Retirement"],
    tooltipText: "This value represents the total amount needed annually at the start of retirement to maintain your lifestyle. It accounts for the compounding effect of the selected inflation rate on your current budget.",
  },
  {
    name: "Housing (Taxes, Insurance, Upkeep)",
    modules:["Retirement"],
    tooltipText: "Enter the total annual cost of maintaining your primary residence in retirement, including property taxes, homeowners insurance, and routine maintenance/repairs.",
  },
  {
    name: "Healthcare (Premiums, Out-of-Pocket)",
    modules:["Retirement"],
    tooltipText: "Estimate your annual costs for Medicare premiums, supplemental insurance, and anticipated out-of-pocket medical or dental expenses.",
  },
  {
    name: "Travel & Leisure",
    modules:["Retirement"],
    tooltipText: "Budget for your retirement adventures. This includes annual costs for vacations, hobbies, club memberships, and entertainment.",
  },
  {
    name: "Daily Living (Food, Utilities, etc.)",
    modules:["Retirement"],
    tooltipText: "Covers your fundamental household overhead, including groceries, dining out, electricity, water, internet, and transportation costs.",
  },
  {
    name: "Other Expenses",
    modules:["Retirement"],
    tooltipText: "A catch-all for any unique annual costs not covered in the categories above, such as charitable giving, supporting family members, or life insurance premiums.",
  },
  {
    name: "Total Annual Retirement Income",
    modules:["Retirement"],
    tooltipText: "This is the calculated sum of all income sources (Social Security, part-time work, and other income) projected for your first year of retirement. It represents the \"floor\" of your retirement funding.",
  },
  {
    name: "Your Estimated Social Security",
    modules:["Retirement"],
    tooltipText: "Note: This value is pulled directly from the Social Security module based on your primary benefit calculation. Please complete that module first to ensure this amount is accurate.",
  },
  {
    name: "Social Security - Spouse",
    modules:["Retirement"],
    tooltipText: "Note: This represents your spouse's projected benefit, synced from the Social Security module. We recommend finishing that section first to capture the correct joint benefit strategy.",
  },
  {
    name: "Your Estimated Social Security Start Age",
    modules:["Retirement"],
    tooltipText: "The age at which you plan to begin taking benefits (between 62 and 70). This value is imported from your selections in the Social Security module.",
  },
  {
    name: "Social Security - Spouse Start Age",
    modules:["Retirement"],
    tooltipText: "The age at which your spouse plans to begin taking benefits. This value is imported from the Social Security module.",
  },
  {
    name: "Part-time Work During Retirement",
    modules:["Retirement"],
    tooltipText: "Enter any supplemental annual income you expect to earn from consulting, hobby jobs, or seasonal work during your retirement years.",
  },
  {
    name: "Other Retirement Income",
    modules:["Retirement"],
    tooltipText: "Note: The entries in this table are directly imported from the Income module. To add, remove, or permanently edit these sources, please complete the Income module first for a seamless transition.",
  },
  {
    name: "Projected Annual Amount",
    modules:["Retirement"],
    tooltipText: "The estimated gross annual payment from this specific income source at the time it begins.",
  },
  {
    name: "Active Duration (Timeline)",
    modules:["Retirement"],
    tooltipText: "The specific dates or timeframe during which this income will be received. This ensures the model only counts the money while it is actually hitting your bank account.",
  },
  {
    name: "Annual Growth (COLA) %",
    modules:["Retirement"],
    tooltipText: "The annual Cost of Living Adjustment (COLA) or growth rate for this income source. Use this to account for pensions with inflation protection or expected raises in part-time work.",
  },
  {
    name: "Tax Status",
    modules:["Retirement"],
    tooltipText: "Defines how this income is treated for tax purposes (e.g., Ordinary Income, Tax-Exempt, etc.). This is critical for calculating your \"Net\" spendable cash flow.",
  },
  {
    name: "Action Income",
    modules:["Retirement"],
    tooltipText: "Use this to toggle specific income sources on or off within this \"What-If\" scenario to see how their absence or presence affects your long-term Wealth Path.",
  },
  {
    name: "Total Liquid Nest Egg",
    modules:["Retirement"],
    tooltipText: "This is the projected total value of all your investable assets (Brokerage, 401(k), IRA, etc.) on the day you retire. Note: This figure accounts for the ongoing growth of your current holdings plus the estimated proceeds from any planned asset sales (like downsizing a home) before your retirement date.",
  },
  {
    name: "Projected Safe Withdrawal Rate",
    modules:["Retirement"],
    tooltipText: "This represents a historically \"safe\" amount you can withdraw from your nest egg annually, adjusted for inflation, with a high probability of not outliving your money over a 30-year retirement. How it's calculated: We take your Total Liquid Nest Egg and multiply it by 4%. While this is a standard industry benchmark, your actual \"safe\" rate may vary based on your specific risk tolerance and market conditions.",
  },
  {
    name: "Total Savings Goal at Retirement",
    modules:["Retirement"],
    tooltipText: "The total capital required on your retirement date to fully fund your desired lifestyle through your plan end age. Derived from: This is calculated by taking your Net Annual Pre-Retirement Budget (adjusted for inflation) and subtracting guaranteed income (Social Security/Pensions) to find the \"gap\" that your portfolio must fill.",
  },
  {
    name: "Projected Value (with current savings)",
    modules:["Retirement"],
    tooltipText: "The estimated value of your accounts at retirement if you continue your current savings rate and asset allocation. Derived from: This pulls your current balances from the Assets module and applies the growth rates set in your Portfolio assumptions.",
  },
  {
    name: "Required Additional Monthly Savings",
    modules:["Retirement"],
    tooltipText: "The monthly \"gap\" you need to fill to reach your goal. Formula: This is the monthly contribution required to grow your Projected Value to meet the Total Savings Goal, assuming a level savings rate until your retirement date.",
  },
  {
    name: "Your Proposed Monthly Savings",
    modules:["Retirement"],
    tooltipText: "This is your \"What-If\" lever. Adjust this to see how increasing or decreasing your monthly savings changes your Wealth Path Trajectory. Function: This starts as a mirror of your \"Required\" savings but can be manually adjusted to test different budget scenarios.",
  },
  {
    name: "Suggested Allocation (monthly)",
    modules:["Retirement"],
    tooltipText: (  
      <div>A strategic breakdown of where to place your Proposed Monthly Savings to maximize tax efficiency.
        <ul>
          <li>Tax-Deferred: Contributions to traditional 401(k)s or IRAs to lower current taxable income.</li>
          <li>Tax-Free: Contributions to Roth accounts or HSAs for tax-free growth and distributions.</li>
          <li>Taxable: Contributions to standard brokerage accounts or high-yield savings.</li>
          <li>Derived from: These limits are based on current IRS contribution maximums for your age and income level."</li>
        </ul>
    </div>
  ),
  },
  {
    name: "Plan Net After Tax (annual)",
    modules:["Retirement"],
    tooltipText: "The estimated annual surplus or deficit in your plan after all retirement expenses and taxes have been paid. Derived from: This is the final output of the Wealth Path math. A green \"$0.00\" or positive number indicates a sustainable plan; a red negative number indicates a projected shortfall.",
  },
  {
    name: "Year",
    modules:["Retirement"],
    tooltipText: "The specific calendar year for this row of the projection.",
  },
  {
    name: "Age",
    modules:["Retirement"],
    tooltipText: "The ages of both you and your spouse during this calendar year.",
  },
  {
    name: "Annual Spending Need (Inflated)",
    modules:["Retirement"],
    tooltipText: "Your target lifestyle budget for this year, adjusted upward by your chosen inflation rate from the Tax and Inflation module.",
  },
  {
    name: "Income Sources",
    modules:["Retirement"],
    tooltipText: "Fixed income that hits your bank account before you touch your investment portfolio.",
  },
  {
    name: "Portfolio Withdrawal Need",
    modules:["Retirement"],
    tooltipText: "",
  },
  {
    name: "The \"Gap.\" This is your Annual Spending Need minus all Income Sources. It represents the amount you must withdraw from your Taxable, Tax-Deferred, and Tax-Free assets to stay solvent this year.",
    modules:["Retirement"],
    tooltipText: "",
  },
  {
    name: "Start Balance",
    modules:["Retirement"],
    tooltipText: "The value of this specific account bucket on January 1st of this year.",
  },
  {
    name: "Growth",
    modules:["Retirement"],
    tooltipText: "The estimated dollar amount of appreciation and interest earned based on the rates set in your Portfolio assumptions.",
  },
  {
    name: "RMD",
    modules:["Retirement"],
    tooltipText: "The government-mandated withdrawal amount for Tax-Deferred accounts (like Traditional IRAs or 401ks) based on your age and IRS life expectancy tables.",
  },
  {
    name: "Withdrawals",
    modules:["Retirement"],
    tooltipText: "The amount taken from this specific bucket to help cover your Portfolio Withdrawal Need.",
  },
  {
    name: "End Balance",
    modules:["Retirement"],
    tooltipText: "The value of this account bucket on December 31st, after growth has been added and withdrawals/RMDs have been removed.",
  },
  {
    name: "Total Withdrawals",
    modules:["Retirement"],
    tooltipText: "The combined amount taken from all three asset buckets this year to cover spending and taxes.",
  },
  {
    name: "Total Pre-Tax Income",
    modules:["Retirement"],
    tooltipText: "The sum of all taxable inflows, including Social Security (taxable portion), Pensions, and Tax-Deferred withdrawals/RMDs.",
  },
  {
    name: "State Tax",
    modules:["Retirement"],
    tooltipText: "The estimated income tax liability based on the rules and rates established in the Taxation module. Note: These calculations factor in your state of residence and the specific tax treatment of each income type.",
  },
  {
    name: "Fed Tax",
    modules:["Retirement"],
    tooltipText: "The sum of all your account buckets at the end of the year. This is the value plotted on your Wealth Path Trajectory chart.",
  },
   {
    name: "Total Ending Balance",
    modules:["Retirement"], 
    tooltipText: "The sum of all your account buckets at the end of the year. This is the value plotted on your Wealth Path Trajectory chart.",
  },

  {
    name: "Refresh Assets",
    tooltipText: "Re-fetches the most recent values from the Asset Planet database for all accounts in this category. This ensures that any recent manual adjustments or background updates are reflected in your current totals. Note: This button updates your view based on information already stored in our system; it does not trigger a new communication with your financial institutions. To pull the latest balances from your bank, please use the Refresh feature in the Link Bank module.",
  },
  {
    name: "Refresh Liabilities",
    tooltipText: "Re-fetches the most recent values from the Asset Planet database for all accounts in this category. This ensures that any recent manual adjustments or background updates are reflected in your current totals. Note: This button updates your view based on information already stored in our system; it does not trigger a new communication with your financial institutions. To pull the latest balances from your bank, please use the Refresh feature in the Link Bank module.",
  },
  {
    name: "Refresh Budget",
    tooltipText: "Re-fetches the most recent values from the Asset Planet database for all accounts in this category. This ensures that any recent manual adjustments or background updates are reflected in your current totals. Note: This button updates your view based on information already stored in our system; it does not trigger a new communication with your financial institutions. To pull the latest balances from your bank, please use the Refresh feature in the Link Bank module.",
  },
  {
    name: "Refresh Link Bank",
    tooltipText: "This triggers a cross-module synchronization that pulls the latest balance and transaction data from all of your linked financial institutions via the Plaid API. This is the master trigger for updating your entire plan with real-time bank data. Once complete, your Assets, Liabilities, and Budget modules will all be updated with the most current information available.",
  },
  {
    name: "Refresh Budget Transactions",
    tooltipText: "Re-fetches transactions from the Asset Planet database for the selected timeframe. This ensures your transaction list reflects all data currently stored in our system, including any recent manual edits or categorization changes. Note: This does not call the Plaid API; to fetch new transactions from your bank, use the Refresh button in the Link Bank module.",
  },
  {
    name: "add_widget",
    tooltipText: "Customize your view. Click here to browse and add new financial modules, tracking tools, or market data widgets to your active dashboard.",
  },
  {
    name: "onboarding",
    tooltipText: "Launch the setup wizard. We'll walk you through connecting your accounts and setting up your profile to ensure your data is accurate and complete.",
  },
  {
    name: "save_dashboard_setting",
    tooltipText: "Make it permanent. Save your current layout, widget positions, and toggle settings so your dashboard looks exactly like this every time you log in.",
  },
  {
    name: "dashboard_tabs",
    tooltipText: "Switch your perspective. Toggle between specialized layouts (like Investments or Goals) to focus on specific areas of your financial plan.",
  },
  //Advisor Panel
  {
    name: "manual_sync",
    tooltipText: "Force an immediate update. While the system syncs daily, use this to manually refresh account balances and client data across all linked integrations right now.",
  },
  {
    name: "add_new_client",
    tooltipText: "Create a new client profile. This opens a fresh financial planning environment where you can begin the data gathering and onboarding process for a new household.",
  },
  {
    name: "total_clients",
    tooltipText: "The total number of unique client profiles currently stored in your database, regardless of active status.",
  },
  {
    name: "total_slots",
    tooltipText: "Your current subscription capacity. This represents the maximum number of full-access client profiles allowed under your current plan.",
  },
  {
    name: "active_clients",
    tooltipText: "Full-access profiles. Active clients can log in to all modules with subscriber-level permissions. Their account balances (including Plaid integrations) refresh automatically upon login.",
  },
  {
    name: "inactive_clients",
    tooltipText: "Inactive profiles. Clients lose login and module access, and automated balance refreshes are paused. The advisor retains full access to all existing data and modules.",
  },
  {
    name: "available_seats",
    tooltipText: "Remaining activation capacity. This shows how many more clients can be granted 'Active' status (up to a maximum of 10) for full platform access and live data syncing.",
  },
  {
    name: "prospect_pass",
    tooltipText: "48-hour full access. Allows a new client to log in and use all modules even if you are at your 10-seat limit. After 48 hours, the client becomes Inactive. Passes have a 30-day cooldown after use.",
  },
];
